<template>
  <div class="ObjPopupdetail" v-loading="detailLoading">
    <!-- 查看rfq详情 -->
    <div class="RFQdetailBox detailBox" v-if="ObjPopupData.type == 'RFQ'">
      <div class="flexpane_header">
        <div class="flex aic jc-c" @click="Closedetail">
          <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path
                d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                id="left__a" />
            </defs>
            <use xlink:href="#left__a" fill-rule="evenodd" />
          </svg>
        </div>
        <div class="flexpane__subtitle">
          {{ $t("slack.RFQID") }} :
          {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
        </div>
      </div>
      <template v-if="ObjPopupData.slackType == 'MyRFQ'">
        <div class="detail_body">
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="headerInfo">
              <p class="Contacts" style="margin-top: 0">
                <span>{{ $t("slack.Vendor") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.RfqVendor || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span style="color: #3370ff" @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.RfqVendor || "-" }}
                  </span>
                </el-tooltip>
              </p>
              <p class="Contacts">
                <span>{{ $t("slack.VendorContacts") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.Rfqsales || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.Rfqsales || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
          </template>
          <template v-else>
            <div class="headerInfo">
              <p class="Contacts" style="margin-top: 0">
                <span>{{ $t("slack.Vendor") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.RfqVendor1 || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span style="color: #3370ff" @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.RfqVendor1 || "-" }}
                  </span>
                </el-tooltip>
              </p>
              <p class="Contacts">
                <span>{{ $t("slack.VendorContacts") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.Rfqsales1 || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.Rfqsales1 || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
          </template>
          <div class="itemBox ModelBox">
            <p class="infoTitle">
              {{ $t("slack.Models") }} ({{
                ObjPopupData.RFQdata.data.length >= 10 ||
                  ObjPopupData.RFQdata.data.length == 0
                  ? ObjPopupData.RFQdata.data.length
                  : "0" + ObjPopupData.RFQdata.data.length
              }})
            </p>
            <div class="Modelwrap">
              <div class="Model" v-for="(item, index) in ObjPopupData.RFQdata.data" :key="index">
                <el-tooltip effect="dark" :content="item.product.model +
                  ' * ' +
                  item.Qty +
                  ' - ' +
                  item.brand.brand_name
                  " placement="bottom" :disabled="isShowTooltip">
                  <p @mouseenter="getWidth($event)">
                    {{ item.product.model }} * {{ item.Qty }} -
                    {{ item.brand.brand_name }}
                  </p>
                </el-tooltip>
              </div>
              <p v-if="ObjPopupData.RFQdata.data.length == 0">
                {{ NoDataText }}
              </p>
            </div>
            <p class="bottomInfo">
              {{ $t("slack.CreatedBy") }}
              {{ ObjPopupData.RFQdata.inquiryInfo.createUser }},
              {{
                getTime(ObjPopupData.RFQdata.inquiryInfo.qtn_create_time, "/")
              }}
            </p>
          </div>
          <div class="itemBox ContactQTNBox f14">
            <div class="TitleBox">
              <template v-if="!detailInfo.showSearch1">
                <p>
                  {{ $t("slack.RelatedQTN") }} ({{
                    ObjPopupData.ContactQTNcount
                  }})
                </p>
                <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.ContactQTNcount > 0"
                  @click="detailInfo.showSearch1 = true"></i>
              </template>
              <template v-if="detailInfo.showSearch1">
                <el-input v-model.trim="detailInfo.keywords1" clearable @input="inputContactQTN" placeholder="Search"
                  prefix-icon="Search" />
                <el-icon class="deleteIcon" @click="
                  () => {
                    detailInfo.showSearch1 = false;
                    detailInfo.keywords1 = '';
                    inputContactQTN('');
                  }
                ">
                  <Close />
                </el-icon>
              </template>
            </div>
            <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
              <div class="QTNBox">
                <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                <p>
                  {{ $t("slack.Condition") }}:
                  {{ item.product_condition || "-" }}
                </p>
                <p>{{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}</p>
                <p class="Price">
                  {{ $t("slack.Price") }}:
                  <i v-show="item.quotation_price" :class="[
                    getCurrencyIcon(item.quotation_price_current),
                    'iconfont f14',
                  ]"></i>
                  <span>{{ item.quotation_price || "-" }}</span>
                </p>
                <div class="bottomInfo" v-if="userInfo.type != 4">
                  {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                </div>
                <button @click="sendQTN(item, 'MyQTN')">
                  <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                    <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="ObjPopupData.slackType == 'ContactsRFQ'">
        <div class="detail_body">
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="headerInfo">
              <p class="Contacts" style="margin-top: 0">
                <span>{{ $t("slack.Sales") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                  </span>
                </el-tooltip>
              </p>
              <!-- <p class="Contacts">
                <span>{{ $t("slack.Contacts") }}:</span>
                <el-tooltip
                  effect="dark"
                  :content="ObjPopupData.RFQdata.inquiryInfo.contact || '-'"
                  :disabled="isShowTooltip"
                  placement="bottom"
                >
                  <span style="color: #3370ff" @mouseenter="getWidth($event)">
                    {{
                    ObjPopupData.RFQdata.inquiryInfo.contact || "-"
                    }}
                  </span>
                </el-tooltip>
              </p> -->
            </div>
          </template>
          <template v-else>
            <div class="headerInfo" v-if="userInfo.type != 4">
              <p class="Sales">
                <span>{{ $t("slack.Sales") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
            <!-- <div class="headerInfo" v-if="userInfo.type == 4">
              <p
                class="Contacts"
                @click="
                getvendorsDetails(
                'RFQ',
                ObjPopupData.RFQdata.inquiryInfo.vendor
              )"
                style="margin-top:0"
              >
                <span>{{ $t("slack.Vendor") }}:</span>
                <el-tooltip
                  effect="dark"
                  :content="ObjPopupData.RFQdata.inquiryInfo.vendor || '-'"
                  :disabled="isShowTooltip"
                  placement="bottom"
                >
                  <span style="color: #3370ff" @mouseenter="getWidth($event)">
                    {{
                    ObjPopupData.RFQdata.inquiryInfo.vendor || "-"
                    }}
                  </span>
                </el-tooltip>
              </p>
              <p class="Contacts">
                <span>{{ $t("slack.VendorContacts") }}:</span>
                <el-tooltip
                  effect="dark"
                  :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                  :disabled="isShowTooltip"
                  placement="bottom"
                >
                  <span @mouseenter="getWidth($event)">
                    {{
                    ObjPopupData.RFQdata.inquiryInfo.sales || "-"
                    }}
                  </span>
                </el-tooltip>
              </p>
            </div>-->
          </template>
          <div class="itemBox ModelBox">
            <p class="infoTitle">
              {{ $t("slack.Models") }} ({{
                ObjPopupData.RFQdata.data.length >= 10 ||
                  ObjPopupData.RFQdata.data.length == 0
                  ? ObjPopupData.RFQdata.data.length
                  : "0" + ObjPopupData.RFQdata.data.length
              }})
            </p>
            <div class="Modelwrap">
              <div class="Model" v-for="(item, index) in ObjPopupData.RFQdata.data" :key="index">
                <el-tooltip effect="dark" :content="item.product.model +
                  ' * ' +
                  item.Qty +
                  ' - ' +
                  item.brand.brand_name
                  " :disabled="isShowTooltip" placement="bottom">
                  <p @mouseenter="getWidth($event)">
                    {{ item.product.model }} * {{ item.Qty }} -
                    {{ item.brand.brand_name }}
                  </p>
                </el-tooltip>
              </div>
              <p v-if="ObjPopupData.RFQdata.data.length == 0">
                {{ NoDataText }}
              </p>
            </div>
            <p class="bottomInfo">
              {{ $t("slack.CreatedBy") }}
              {{ ObjPopupData.RFQdata.inquiryInfo.createUser }},
              {{
                getTime(ObjPopupData.RFQdata.inquiryInfo.qtn_create_time, "/")
              }}
            </p>
          </div>
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="itemBox PurchaseQTNBox">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch">
                  <p>
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      ObjPopupData.PurchaseQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch = true"
                    v-if="ObjPopupData.PurchaseQTNcount > 0"></i>
                </template>
                <template v-if="detailInfo.showSearch">
                  <el-input v-model.trim="detailInfo.keywords" clearable placeholder="Search" prefix-icon="Search"
                    @input="inputPurchaseQTN" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch = false;
                      detailInfo.keywords = '';
                      inputPurchaseQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item" :key="'PurchaseQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'PurchaseQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="itemBox ContactQTNBox">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch1">
                  <p>
                    {{ $t("slack.RelatedContactQTN") }} ({{
                      ObjPopupData.ContactQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch1 = true"
                    v-if="ObjPopupData.ContactQTNcount > 0"></i>
                </template>
                <template v-if="detailInfo.showSearch1">
                  <el-input v-model.trim="detailInfo.keywords1" clearable placeholder="Search" prefix-icon="Search"
                    @input="inputContactQTN" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch1 = false;
                      detailInfo.keywords1 = '';
                      inputContactQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'ContactQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="userInfo.type == 3">
              <div class="itemBox PurchaseQTNBox">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch">
                    <p>
                      {{ $t("slack.RelatedPurchaseQTN") }} ({{
                        ObjPopupData.PurchaseQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch = true"
                      v-if="ObjPopupData.PurchaseQTNcount > 0"></i>
                  </template>
                  <template v-if="detailInfo.showSearch">
                    <el-input v-model.trim="detailInfo.keywords" clearable placeholder="Search" prefix-icon="Search"
                      @input="inputPurchaseQTN" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch = false;
                        detailInfo.keywords = '';
                        inputPurchaseQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item"
                  :key="'PurchaseQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <p style="color: #e96c45" v-if="userInfo.type != 4">
                      {{ $t("slack.Cost") }}:
                      <i v-show="item.purchase_price" :class="[
                        getCurrencyIcon(item.quotation_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.purchase_price || "-" }}</span>
                    </p>
                    <!-- <p class="Price">
                    {{ $t("slack.Price") }}: ${{ item.quotation_price }}
                    </p>-->
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'PurchaseQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="itemBox PurchaseQTNBox">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch">
                    <p>
                      {{ $t("slack.RelatedPurchaseQTN") }} ({{
                        ObjPopupData.PurchaseQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch = true"
                      v-if="ObjPopupData.PurchaseQTNcount > 0"></i>
                  </template>
                  <template v-if="detailInfo.showSearch">
                    <el-input v-model.trim="detailInfo.keywords" clearable placeholder="Search" prefix-icon="Search"
                      @input="inputPurchaseQTN" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch = false;
                        detailInfo.keywords = '';
                        inputPurchaseQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item"
                  :key="'PurchaseQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <p v-if="userInfo.type != 4">
                      {{ $t("slack.Cost") }}:
                      <i v-show="item.purchase_price" :class="[
                        getCurrencyIcon(item.quotation_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.purchase_price || "-" }}</span>
                    </p>
                    <p class="Price">
                      {{ $t("slack.Price") }}:
                      <i v-show="item.quotation_price" :class="[
                        getCurrencyIcon(item.quotation_price_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.quotation_price || "-" }}</span>
                    </p>
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'PurchaseQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="itemBox ContactQTNBox">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch1">
                    <p>
                      {{ $t("slack.RelatedContactQTN") }} ({{
                        ObjPopupData.ContactQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch1 = true"
                      v-if="ObjPopupData.ContactQTNcount > 0"></i>
                  </template>
                  <template v-if="detailInfo.showSearch1">
                    <el-input v-model.trim="detailInfo.keywords1" clearable placeholder="Search" prefix-icon="Search"
                      @input="inputContactQTN" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch1 = false;
                        detailInfo.keywords1 = '';
                        inputContactQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <!-- <p>{{ $t("slack.Cost") }}: $ {{ item.purchase_price }}</p> -->
                    <p class="Price">
                      {{ $t("slack.Price") }}:
                      <i v-show="item.quotation_price" :class="[
                        getCurrencyIcon(item.quotation_price_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.quotation_price || "-" }}</span>
                    </p>
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'ContactQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="detail_body">
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="headerInfo">
              <p class="Contacts" style="margin-top: 0">
                <span>{{ $t("slack.Sales") }}:</span>
                <span>{{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}</span>
              </p>
            </div>
          </template>
          <template v-else>
            <div class="headerInfo" v-if="userInfo.type == 3">
              <p class="Sales">
                <span>{{ $t("slack.Sales") }}:</span>
                <span>{{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}</span>
              </p>
            </div>
          </template>
          <div class="itemBox ModelBox">
            <p class="infoTitle">
              {{ $t("slack.Models") }} ({{
                ObjPopupData.RFQdata.data.length >= 10 ||
                  ObjPopupData.RFQdata.data.length == 0
                  ? ObjPopupData.RFQdata.data.length
                  : "0" + ObjPopupData.RFQdata.data.length
              }})
            </p>
            <div class="Modelwrap">
              <div class="Model" v-for="(item, index) in ObjPopupData.RFQdata.data" :key="index">
                <el-tooltip effect="dark" :content="item.product.model +
                  ' * ' +
                  item.Qty +
                  ' - ' +
                  item.brand.brand_name
                  " :disabled="isShowTooltip" placement="bottom">
                  <p @mouseenter="getWidth($event)">
                    {{ item.product.model }} * {{ item.Qty }} -
                    {{ item.brand.brand_name }}
                  </p>
                </el-tooltip>
              </div>
              <p v-if="ObjPopupData.RFQdata.data.length == 0">
                {{ NoDataText }}
              </p>
            </div>
            <p class="bottomInfo">
              {{ $t("slack.CreatedBy") }}
              {{ ObjPopupData.RFQdata.inquiryInfo.createUser }},
              {{
                getTime(ObjPopupData.RFQdata.inquiryInfo.qtn_create_time, "/")
              }}
            </p>
          </div>
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="itemBox PurchaseQTNBox">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch">
                  <p>
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      ObjPopupData.PurchaseQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch = true"
                    v-if="ObjPopupData.PurchaseQTNcount > 0"></i>
                </template>
                <template v-if="detailInfo.showSearch">
                  <el-input v-model.trim="detailInfo.keywords" clearable placeholder="Search" prefix-icon="Search"
                    @input="inputPurchaseQTN" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch = false;
                      detailInfo.keywords = '';
                      inputPurchaseQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item" :key="'PurchaseQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'PurchaseQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="itemBox ContactQTNBox">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch1">
                  <p>
                    {{ $t("slack.RelatedContactQTN") }} ({{
                      ObjPopupData.ContactQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch1 = true"
                    v-if="ObjPopupData.ContactQTNcount > 0"></i>
                </template>
                <template v-if="detailInfo.showSearch1">
                  <el-input v-model.trim="detailInfo.keywords1" clearable placeholder="Search" prefix-icon="Search"
                    @input="inputContactQTN" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch1 = false;
                      detailInfo.keywords1 = '';
                      inputContactQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'ContactQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="userInfo.type == 3">
              <div class="itemBox PurchaseQTNBox">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch">
                    <p>
                      {{ $t("slack.RelatedPurchaseQTN") }} ({{
                        ObjPopupData.PurchaseQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch = true"
                      v-if="ObjPopupData.PurchaseQTNcount > 0"></i>
                  </template>
                  <template v-if="detailInfo.showSearch">
                    <el-input v-model.trim="detailInfo.keywords" clearable placeholder="Search" prefix-icon="Search"
                      @input="inputPurchaseQTN" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch = false;
                        detailInfo.keywords = '';
                        inputPurchaseQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item"
                  :key="'PurchaseQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <p style="color: #e96c45" v-if="userInfo.type != 4">
                      {{ $t("slack.Cost") }}:
                      <i v-show="item.purchase_price" :class="[
                        getCurrencyIcon(item.quotation_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.purchase_price || "-" }}</span>
                    </p>
                    <!-- <p class="Price">
                    {{ $t("slack.Price") }}: ${{ item.quotation_price }}
                    </p>-->
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'PurchaseQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="itemBox ContactQTNBox">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch1">
                    <p>
                      {{ $t("slack.RelatedContactQTN") }} ({{
                        ObjPopupData.ContactQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" @click="detailInfo.showSearch1 = true"
                      v-if="ObjPopupData.ContactQTNcount > 0"></i>
                  </template>
                  <template v-if="detailInfo.showSearch1">
                    <el-input v-model.trim="detailInfo.keywords1" clearable placeholder="Search" prefix-icon="Search"
                      @input="inputContactQTN" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch1 = false;
                        detailInfo.keywords1 = '';
                        inputContactQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <!-- <p>{{ $t("slack.Cost") }}: $ {{ item.purchase_price }}</p> -->
                    <p class="Price">
                      {{ $t("slack.Price") }}:
                      <i v-show="item.quotation_price" :class="[
                        getCurrencyIcon(item.quotation_price_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.quotation_price || "-" }}</span>
                    </p>
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'ContactQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </template>
    </div>
    <!-- 查看QTN详情 -->
    <div class="QTNdetailBox detailBox" v-if="ObjPopupData.type == 'QTN'">
      <template v-if="ObjPopupData.slackType == 'PurchaseQTN'">
        <div class="flexpane_header">
          <div class="flex aic jc-c" @click="Closedetail">
            <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                  id="left__a" />
              </defs>
              <use xlink:href="#left__a" fill-rule="evenodd" />
            </svg>
          </div>
          <div class="flexpane__subtitle">
            {{ $t("slack.QTNID") }} :
            {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
          </div>
        </div>
        <div class="detail_body">
          <div class="headerInfo" v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <p class="Sales">
              <span>{{ $t("slack.Sales") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                :disabled="isShowTooltip" placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p class="Contacts">
              <span>{{ $t("slack.Purchaser") }}:</span>
              <span>{{ dialogueInfo.nickname }}</span>
              <!-- <span
                v-if="ObjPopupData.PurchaseQTN.item"
              >{{ObjPopupData.PurchaseQTN.item[0].purchaser_id_name[0] || '-'}}</span>-->
            </p>
          </div>
          <div v-else>
            <div class="headerInfo">
              <p class="Sales">
                <span>{{ $t("slack.Sales") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                  </span>
                </el-tooltip>
              </p>
              <p class="Contacts">
                <span>{{ $t("slack.Purchaser") }}:</span>
                <el-tooltip effect="dark" :content="userInfo.UserGroupName || '-'" :disabled="isShowTooltip"
                  placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ userInfo.UserGroupName || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <template v-if="
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user ==
            userInfo.user_uid ||
            userInfo.type == 1 ||
            userInfo.type == 6
          ">
            <div class="itemBox PurchaseQTNBox f14">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch">
                  <p>
                    {{ $t("slack.PurchaseQTN") }} ({{
                      ObjPopupData.PurchaseQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.PurchaseQTNcount < 10"
                    @click="detailInfo.showSearch = true"></i>
                </template>
                <template v-if="detailInfo.showSearch">
                  <el-input v-model.trim="detailInfo.keywords" clearable @input="inputPurchaseQTN" placeholder="Search"
                    prefix-icon="Search" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch = false;
                      detailInfo.keywords = '';
                      inputPurchaseQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item" :key="'PurchaseQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'PurchaseQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="itemBox f14">
              <div class="TitleBox">
                <p>{{ $t("slack.RelatedRFQ") }}</p>
              </div>
              <div class="RelatedRFQ">
                <p>
                  <span>{{ $t("slack.RFQ") }} ID:</span>
                  <span>{{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}</span>
                </p>
                <p>
                  <span>{{ $t("slack.Sales") }}:</span>
                  <span>
                    {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                  </span>
                </p>
                <!-- <p
                  class="Contacts"
                  @click="
                    getContactsDetails(
                      'QTN',
                      ObjPopupData.RFQdata.inquiryInfo.contact
                    )
                  "
                >
                  <span>{{ $t("slack.Contacts") }}:</span>
                  <el-tooltip
                    effect="dark"
                    :content="ObjPopupData.RFQdata.inquiryInfo.contact || '-'"
                    :disabled="isShowTooltip"
                    placement="bottom"
                  >
                    <span @mouseenter="getWidth($event)" style="color: #3370ff">
                      {{
                      ObjPopupData.RFQdata.inquiryInfo.contact || "-"
                      }}
                    </span>
                  </el-tooltip>
                </p>-->
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="userInfo.type == 3">
              <div class="itemBox PurchaseQTNBox f14">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch">
                    <p>
                      {{ $t("slack.PurchaseQTN") }} ({{
                        ObjPopupData.PurchaseQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.PurchaseQTNcount > 0"
                      @click="detailInfo.showSearch = true"></i>
                  </template>
                  <template v-if="detailInfo.showSearch">
                    <el-input v-model.trim="detailInfo.keywords" clearable @input="inputPurchaseQTN"
                      placeholder="Search" prefix-icon="Search" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch = false;
                        detailInfo.keywords = '';
                        inputPurchaseQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item"
                  :key="'PurchaseQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <p style="color: #e96c45" v-if="userInfo.type != 4">
                      {{ $t("slack.Cost") }}:
                      <i v-show="item.purchase_price" :class="[
                        getCurrencyIcon(item.quotation_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.purchase_price || "-" }}</span>
                    </p>
                    <!-- <p class="Price">
                      {{ $t("slack.Price") }}: ${{ item.quotation_price }}
                    </p>-->
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'PurchaseQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="itemBox f14">
                <div class="TitleBox">
                  <p>{{ $t("slack.RelatedRFQ") }}</p>
                </div>
                <div class="RelatedRFQ">
                  <p>
                    <span>{{ $t("slack.RFQ") }} ID:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
                    </span>
                  </p>
                  <p>
                    <span>{{ $t("slack.Sales") }}:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                    </span>
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="itemBox PurchaseQTNBox f14">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch">
                    <p>
                      {{ $t("slack.PurchaseQTN") }} ({{
                        ObjPopupData.PurchaseQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.PurchaseQTNcount > 0"
                      @click="detailInfo.showSearch = true"></i>
                  </template>
                  <template v-if="detailInfo.showSearch">
                    <el-input v-model.trim="detailInfo.keywords" clearable @input="inputPurchaseQTN"
                      placeholder="Search" prefix-icon="Search" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch = false;
                        detailInfo.keywords = '';
                        inputPurchaseQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item"
                  :key="'PurchaseQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <!-- <p>{{ $t("slack.Cost") }}: $ {{ item.purchase_price }}</p> -->
                    <p class="Price">
                      {{ $t("slack.Price") }}:
                      <i v-show="item.quotation_price" :class="[
                        getCurrencyIcon(item.quotation_price_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.quotation_price || "-" }}</span>
                    </p>
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'PurchaseQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="itemBox f14">
                <div class="TitleBox">
                  <p>{{ $t("slack.RelatedRFQ") }}</p>
                </div>
                <div class="RelatedRFQ">
                  <p>
                    <span>{{ $t("slack.RFQ") }} ID:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
                    </span>
                  </p>
                  <p>
                    <span>{{ $t("slack.Sales") }}:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                    </span>
                  </p>
                  <!-- <p
                    class="Contacts"
                    @click="
                      getContactsDetails(
                        'QTN',
                        ObjPopupData.RFQdata.inquiryInfo.contact
                      )
                    "
                  >
                    <span>{{ $t("slack.Contacts") }}:</span>
                    <el-tooltip
                      effect="dark"
                      :content="ObjPopupData.RFQdata.inquiryInfo.contact || '-'"
                      :disabled="isShowTooltip"
                      placement="bottom"
                    >
                      <span @mouseenter="getWidth($event)" style="color: #3370ff">
                        {{
                        ObjPopupData.RFQdata.inquiryInfo.contact || "-"
                        }}
                      </span>
                    </el-tooltip>
                  </p>-->
                </div>
              </div>
            </template>
          </template>

          <div class="itemBox ModelBox">
            <p class="infoTitle">
              {{ $t("slack.Models") }} ({{
                ObjPopupData.RFQdata.data.length >= 10 ||
                  ObjPopupData.RFQdata.data.length == 0
                  ? ObjPopupData.RFQdata.data.length
                  : "0" + ObjPopupData.RFQdata.data.length
              }})
            </p>
            <div class="Modelwrap">
              <div class="Model" v-for="(item, index) in ObjPopupData.RFQdata.data" :key="index">
                <el-tooltip effect="dark" :content="item.product.model +
                  ' * ' +
                  item.Qty +
                  ' - ' +
                  item.brand.brand_name
                  " :disabled="isShowTooltip" placement="bottom">
                  <p @mouseenter="getWidth($event)">
                    {{ item.product.model }} * {{ item.Qty }} -
                    {{ item.brand.brand_name }}
                  </p>
                </el-tooltip>
              </div>
              <p v-if="ObjPopupData.RFQdata.data.length == 0">
                {{ NoDataText }}
              </p>
            </div>
            <p class="bottomInfo">
              {{ $t("slack.CreatedBy") }}
              {{ ObjPopupData.RFQdata.inquiryInfo.createUser }},
              {{
                getTime(ObjPopupData.RFQdata.inquiryInfo.qtn_create_time, "/")
              }}
            </p>
          </div>
        </div>
      </template>
      <template v-if="ObjPopupData.slackType == 'ContactQTN'">
        <div class="flexpane_header">
          <div class="flex aic jc-c" @click="Closedetail">
            <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                  id="left__a" />
              </defs>
              <use xlink:href="#left__a" fill-rule="evenodd" />
            </svg>
          </div>
          <div class="flexpane__subtitle">
            {{ $t("slack.QTNID") }} :
            {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
          </div>
        </div>
        <div class="detail_body">
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="headerInfo">
              <p class="Sales">
                <span>{{ $t("slack.Sales") }}:</span>
                <span>{{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}</span>
              </p>
            </div>
            <div class="itemBox ContactQTNBox f14">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch1">
                  <p>
                    {{ $t("slack.ContactQTN") }} ({{
                      ObjPopupData.ContactQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.ContactQTNcount > 0"
                    @click="detailInfo.showSearch1 = true"></i>
                </template>
                <template v-if="detailInfo.showSearch1">
                  <el-input v-model.trim="detailInfo.keywords1" clearable @input="inputContactQTN" placeholder="Search"
                    prefix-icon="Search" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch1 = false;
                      detailInfo.keywords1 = '';
                      inputContactQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'ContactQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="itemBox PurchaseQTNBox f14">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch">
                  <p>
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      ObjPopupData.PurchaseQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.PurchaseQTNcount > 0"
                    @click="detailInfo.showSearch = true"></i>
                </template>
                <template v-if="detailInfo.showSearch">
                  <el-input v-model.trim="detailInfo.keywords" clearable @input="inputPurchaseQTN" placeholder="Search"
                    prefix-icon="Search" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch = false;
                      detailInfo.keywords = '';
                      inputPurchaseQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item" :key="'PurchaseQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'PurchaseQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="itemBox f14">
              <div class="TitleBox">
                <p>{{ $t("slack.RelatedRFQ") }}</p>
              </div>
              <div class="RelatedRFQ">
                <p>
                  <span>{{ $t("slack.RFQ") }} ID:</span>
                  <span>{{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}</span>
                </p>
                <p>
                  <span>{{ $t("slack.Sales") }}:</span>
                  <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                    :disabled="isShowTooltip" placement="bottom">
                    <span @mouseenter="getWidth($event)">
                      {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                    </span>
                  </el-tooltip>
                </p>

                <!-- <p
                  class="Contacts"
                  @click="
                    getContactsDetails(
                      'QTN',
                      ObjPopupData.RFQdata.inquiryInfo.contact
                    )
                  "
                >
                  <span>{{ $t("slack.Contacts") }}:</span>
                  <el-tooltip
                    effect="dark"
                    :content="ObjPopupData.RFQdata.inquiryInfo.contact || '-'"
                    :disabled="isShowTooltip"
                    placement="bottom"
                  >
                    <span @mouseenter="getWidth($event)" style="color: #3370ff">
                      {{
                      ObjPopupData.RFQdata.inquiryInfo.contact || "-"
                      }}
                    </span>
                  </el-tooltip>
                </p>-->
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="userInfo.type == 3">
              <div class="headerInfo">
                <p class="Sales">
                  <span>{{ $t("slack.Sales") }}:</span>
                  <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.sales || '-'"
                    :disabled="isShowTooltip" placement="bottom">
                    <span @mouseenter="getWidth($event)">
                      {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                    </span>
                  </el-tooltip>
                </p>
              </div>
              <div class="itemBox PurchaseQTNBox f14">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch">
                    <p>
                      {{ $t("slack.PurchaseQTN") }} ({{
                        ObjPopupData.PurchaseQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.PurchaseQTNcount > 0"
                      @click="detailInfo.showSearch = true"></i>
                  </template>
                  <template v-if="detailInfo.showSearch">
                    <el-input v-model.trim="detailInfo.keywords" clearable @input="inputPurchaseQTN"
                      placeholder="Search" prefix-icon="Search" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch = false;
                        detailInfo.keywords = '';
                        inputPurchaseQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item"
                  :key="'PurchaseQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>{{ $t("slack.Leading") }}: {{ item.leadingtime }}</p>
                    <p style="color: #e96c45" v-if="userInfo.type != 4">
                      {{ $t("slack.Cost") }}:
                      <i v-show="item.purchase_price" :class="[
                        getCurrencyIcon(item.quotation_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.purchase_price || "-" }}</span>
                    </p>
                    <!-- <p class="Price">
                          {{ $t("slack.Price") }}: ${{ item.quotation_price }}
                    </p>-->
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }}
                      {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'PurchaseQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="itemBox f14">
                <div class="TitleBox">
                  <p>{{ $t("slack.RelatedRFQ") }}</p>
                </div>
                <div class="RelatedRFQ">
                  <p>
                    <span>{{ $t("slack.RFQ") }} ID:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
                    </span>
                  </p>
                  <p>
                    <span>{{ $t("slack.Sales") }}:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.sales || "-" }}
                    </span>
                  </p>
                </div>
              </div>
            </template>
            <template v-if="userInfo.type != 3">
              <!-- <div class="headerInfo">
                <p
                  class="Sales"
                  @click="
                    getvendorsDetails(
                      'QTN',
                      ObjPopupData.ContactQTN.customer.vendor
                    )
                  "
                >
                  <span>{{ $t("slack.Vendor") }}:</span>
                  <el-tooltip
                    effect="dark"
                    :content="ObjPopupData.ContactQTN.customer.vendor || '-'"
                    :disabled="isShowTooltip"
                    placement="bottom"
                  >
                    <span @mouseenter="getWidth($event)" style="color: #3370ff">
                      {{
                      ObjPopupData.ContactQTN.customer.vendor || "-"
                      }}
                    </span>
                  </el-tooltip>
                </p>
                <p class="Contacts">
                  <span>{{ $t("slack.VendorContacts") }}:</span>
                  <el-tooltip
                    effect="dark"
                    :content="
                      ObjPopupData.ContactQTN.inquiryInfo.contact || '-'
                    "
                    :disabled="isShowTooltip"
                    placement="bottom"
                  >
                    <span @mouseenter="getWidth($event)">
                      {{
                      ObjPopupData.ContactQTN.inquiryInfo.contact || "-"
                      }}
                    </span>
                  </el-tooltip>
                </p>
              </div>-->
              <div class="itemBox ContactQTNBox f14">
                <div class="TitleBox">
                  <template v-if="!detailInfo.showSearch1">
                    <p>
                      {{ $t("slack.ContactQTN") }} ({{
                        ObjPopupData.ContactQTNcount
                      }})
                    </p>
                    <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.ContactQTNcount > 0"
                      @click="detailInfo.showSearch1 = true"></i>
                  </template>
                  <template v-if="detailInfo.showSearch1">
                    <el-input v-model.trim="detailInfo.keywords1" clearable @input="inputContactQTN"
                      placeholder="Search" prefix-icon="Search" />
                    <el-icon class="deleteIcon" @click="
                      () => {
                        detailInfo.showSearch1 = false;
                        detailInfo.keywords1 = '';
                        inputContactQTN('');
                      }
                    ">
                      <Close />
                    </el-icon>
                  </template>
                </div>
                <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                  <div class="stateBox">
                    <p>{{ item.quotation_state_text }}</p>
                    <!-- <p style="color: #3370ff">Action</p> -->
                  </div>
                  <div class="QTNBox">
                    <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                    <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                    <p>
                      {{ $t("slack.Condition") }}:
                      {{ item.product_condition || "-" }}
                    </p>
                    <p>
                      {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                    </p>
                    <!-- <p>{{ $t("slack.Cost") }}: $ {{ item.purchase_price }}</p> -->
                    <p class="Price">
                      {{ $t("slack.Price") }}:
                      <i v-show="item.quotation_price" :class="[
                        getCurrencyIcon(item.quotation_price_current),
                        'iconfont f14',
                      ]"></i>
                      <span>{{ item.quotation_price || "-" }}</span>
                    </p>
                    <div class="bottomInfo" v-if="userInfo.type != 4">
                      {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                    </div>
                    <button @click="sendQTN(item, 'ContactQTN')">
                      <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                        <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="itemBox f14">
                <div class="TitleBox">
                  <p>{{ $t("slack.RelatedRFQ") }}</p>
                </div>
                <div class="RelatedRFQ">
                  <p>
                    <span>{{ $t("slack.RFQ") }} ID:</span>
                    <span>
                      {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
                    </span>
                  </p>
                  <!-- <p>
                    <span>{{ $t("slack.Vendor") }}:</span>
                    <el-tooltip
                      effect="dark"
                      :content="ObjPopupData.ContactQTN.customer.vendor || '-'"
                      :disabled="isShowTooltip"
                      placement="bottom"
                    >
                      <span @mouseenter="getWidth($event)">
                        {{
                        ObjPopupData.ContactQTN.customer.vendor || "-"
                        }}
                      </span>
                    </el-tooltip>
                  </p>-->
                  <!-- <p
                    class="Contacts"
                    @click="
                      getContactsDetails(
                        'QTN',
                        ObjPopupData.RFQdata.inquiryInfo.contact
                      )
                    "
                  >
                    <span>{{ $t("slack.VendorContacts") }}:</span>
                    <el-tooltip
                      effect="dark"
                      :content="ObjPopupData.RFQdata.inquiryInfo.contact || '-'"
                      :disabled="isShowTooltip"
                      placement="bottom"
                    >
                      <span style="color: #3370ff" @mouseenter="getWidth($event)">
                        {{
                        ObjPopupData.RFQdata.inquiryInfo.contact || "-"
                        }}
                      </span>
                    </el-tooltip>
                  </p>-->
                </div>
              </div>
            </template>
          </template>
          <div class="itemBox ModelBox">
            <p class="infoTitle">
              {{ $t("slack.Models") }} ({{
                ObjPopupData.RFQdata.data.length >= 10 ||
                  ObjPopupData.RFQdata.data.length == 0
                  ? ObjPopupData.RFQdata.data.length
                  : "0" + ObjPopupData.RFQdata.data.length
              }})
            </p>
            <div class="Modelwrap">
              <div class="Model" v-for="(item, index) in ObjPopupData.RFQdata.data" :key="index">
                <el-tooltip effect="dark" :content="item.product.model +
                  ' * ' +
                  item.Qty +
                  ' - ' +
                  item.brand.brand_name
                  " placement="bottom" :disabled="isShowTooltip">
                  <p @mouseenter="getWidth($event)">
                    {{ item.product.model }} * {{ item.Qty }} -
                    {{ item.brand.brand_name }}
                  </p>
                </el-tooltip>
              </div>
              <p v-if="ObjPopupData.RFQdata.data.length == 0">
                {{ NoDataText }}
              </p>
            </div>
            <p class="bottomInfo">
              {{ $t("slack.CreatedBy") }}
              {{ ObjPopupData.RFQdata.inquiryInfo.createUser }},
              {{
                getTime(ObjPopupData.RFQdata.inquiryInfo.qtn_create_time, "/")
              }}
            </p>
          </div>
        </div>
      </template>
      <template v-if="ObjPopupData.slackType == 'MyQTN'">
        <div class="flexpane_header">
          <div class="flex aic jc-c" @click="Closedetail">
            <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                  id="left__a" />
              </defs>
              <use xlink:href="#left__a" fill-rule="evenodd" />
            </svg>
          </div>
          <div class="flexpane__subtitle">
            {{ $t("slack.QTNID") }} :
            {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
          </div>
        </div>
        <div class="detail_body scroll">
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.RFQdata.inquiryInfo.ownerId == userInfo.user_uid ||
            ObjPopupData.RFQdata.inquiryInfo.create_user == userInfo.user_uid
          ">
            <div class="headerInfo">
              <!-- @click="
            getvendorsDetails(
            'RFQ',
            ObjPopupData.RFQdata.inquiryInfo.vendor
              )"-->
              <p class="Contacts" style="margin-top: 0">
                <span>{{ $t("slack.Vendor") }}:</span>
                <span style="color: #3370ff">{{
                  ObjPopupData.RFQdata.RfqVendor || "-"
                }}</span>
              </p>
              <p class="Contacts">
                <span>{{ $t("slack.VendorContacts") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.Rfqsales || '-'" :disabled="isShowTooltip"
                  placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.Rfqsales || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
            <div class="itemBox ContactQTNBox f14">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch1">
                  <p>
                    {{ $t("slack.Itmes") }} ({{ ObjPopupData.ContactQTNcount }})
                  </p>
                  <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.ContactQTNcount > 0"
                    @click="detailInfo.showSearch1 = true"></i>
                </template>
                <template v-if="detailInfo.showSearch1">
                  <el-input v-model.trim="detailInfo.keywords1" clearable @input="inputContactQTN" placeholder="Search"
                    prefix-icon="Search" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch1 = false;
                      detailInfo.keywords1 = '';
                      inputContactQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'MyQTN')" v-if="item.purchaser_id == dialogueInfo.id">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="headerInfo">
              <p class="Contacts">
                <span>{{ $t("slack.Sales") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.Rfqsales1 || '-'" :disabled="isShowTooltip"
                  placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.Rfqsales1 || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
            <div class="itemBox ContactQTNBox f14">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch1">
                  <p>
                    {{ $t("slack.ContactQTN") }} ({{
                      ObjPopupData.ContactQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.ContactQTNcount > 0"
                    @click="detailInfo.showSearch1 = true"></i>
                </template>
                <template v-if="detailInfo.showSearch1">
                  <el-input v-model.trim="detailInfo.keywords1" clearable @input="inputContactQTN" placeholder="Search"
                    prefix-icon="Search" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch1 = false;
                      detailInfo.keywords1 = '';
                      inputContactQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.ContactQTN.item" :key="'ContactQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'MyQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="itemBox PurchaseQTNBox f14">
              <div class="TitleBox">
                <template v-if="!detailInfo.showSearch">
                  <p>
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      ObjPopupData.PurchaseQTNcount
                    }})
                  </p>
                  <i class="iconfont icon-sousuo f18" v-if="ObjPopupData.PurchaseQTNcount > 0"
                    @click="detailInfo.showSearch = true"></i>
                </template>
                <template v-if="detailInfo.showSearch">
                  <el-input v-model.trim="detailInfo.keywords" clearable @input="inputPurchaseQTN" placeholder="Search"
                    prefix-icon="Search" />
                  <el-icon class="deleteIcon" @click="
                    () => {
                      detailInfo.showSearch = false;
                      detailInfo.keywords = '';
                      inputPurchaseQTN('');
                    }
                  ">
                    <Close />
                  </el-icon>
                </template>
              </div>
              <div class="QTNItem" v-for="(item, index) in ObjPopupData.PurchaseQTN.item" :key="'PurchaseQTN' + index">
                <div class="stateBox">
                  <p>{{ item.quotation_state_text }}</p>
                  <!-- <p style="color: #3370ff">Action</p> -->
                </div>
                <div class="QTNBox">
                  <p class="Model">{{ item.model }} * {{ item.Qty }}</p>
                  <p>{{ $t("slack.Brand") }}: {{ item.brand_name || "-" }}</p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{ item.product_condition || "-" }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}: {{ item.leadingtime || "-" }}
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Cost") }}:
                    <i v-show="item.purchase_price" :class="[
                      getCurrencyIcon(item.quotation_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.purchase_price || "-" }}</span>
                  </p>
                  <p class="Price">
                    {{ $t("slack.Price") }}:
                    <i v-show="item.quotation_price" :class="[
                      getCurrencyIcon(item.quotation_price_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ item.quotation_price || "-" }}</span>
                  </p>
                  <div class="bottomInfo" v-if="userInfo.type != 4">
                    {{ $t("slack.Quotedby") }} {{ item.purchaser_id_name?item.purchaser_id_name[0]:item.purchaser_name }}
                  </div>
                  <button @click="sendQTN(item, 'MyQTN')">
                    <svg t="1680753032116" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="2780" width="20" height="20">
                      <path d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z" p-id="2781" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <div class="itemBox f14">
            <div class="TitleBox">
              <p>{{ $t("slack.RelatedRFQ") }}</p>
            </div>
            <div class="RelatedRFQ">
              <p>
                <span>{{ $t("slack.RFQ") }} ID:</span>
                <span>
                  {{ ObjPopupData.RFQdata.inquiryInfo.inquiry_id }}
                </span>
              </p>
              <p>
                <span>{{ $t("slack.Owner") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.RFQdata.inquiryInfo.owner || '-'"
                  :disabled="isShowTooltip" placement="bottom">
                  <span @mouseenter="getWidth($event)">
                    {{ ObjPopupData.RFQdata.inquiryInfo.owner || "-" }}
                  </span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="itemBox ModelBox">
            <p class="infoTitle">
              {{ $t("slack.Models") }} ({{
                ObjPopupData.RFQdata.data.length >= 10 ||
                  ObjPopupData.RFQdata.data.length == 0
                  ? ObjPopupData.RFQdata.data.length
                  : "0" + ObjPopupData.RFQdata.data.length
              }})
            </p>
            <div class="Modelwrap">
              <div class="Model" v-for="(item, index) in ObjPopupData.RFQdata.data" :key="index">
                <el-tooltip effect="dark" :content="item.product.model +
                  ' * ' +
                  item.Qty +
                  ' - ' +
                  item.brand.brand_name
                  " :disabled="isShowTooltip" placement="bottom">
                  <p @mouseenter="getWidth($event)">
                    {{ item.product.model }} * {{ item.Qty }} -
                    {{ item.brand.brand_name }}
                  </p>
                </el-tooltip>
              </div>
              <p v-if="ObjPopupData.RFQdata.data.length == 0">
                {{ NoDataText }}
              </p>
            </div>
            <p class="bottomInfo">
              {{ $t("slack.CreatedBy") }}
              {{ ObjPopupData.RFQdata.inquiryInfo.createUser }},
              {{
                getTime(ObjPopupData.RFQdata.inquiryInfo.qtn_create_time, "/")
              }}
            </p>
          </div>
        </div>
      </template>
    </div>
    <!-- 查看SaleOrder详情 -->
    <div class="SaleOrderBox detailBox" v-if="ObjPopupData.type == 'SaleOrder'">
      <div class="flexpane_header">
        <div class="flex aic jc-c" @click="Closedetail">
          <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path
                d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                id="left__a" />
            </defs>
            <use xlink:href="#left__a" fill-rule="evenodd" />
          </svg>
        </div>
        <div class="flexpane__subtitle">
          {{ $t("slack.OrderID") }} : {{ ObjPopupData.SaleOrderData.PI_name }}
        </div>
      </div>
      <div class="detail_body">
        <template v-if="
          userInfo.type == 1 ||
          this.userInfo.type == 6 ||
          ObjPopupData.SaleOrderData.customer.create_user_id ==
          userInfo.user_uid ||
          ObjPopupData.SaleOrderData.customer.Sales_User_ID ==
          userInfo.user_uid
        ">
          <div class="headerInfo">
            <p class="Sales">
              <span>{{ $t("slack.Sales") }}:</span>
              <span>{{ ObjPopupData.SaleOrderData.customer.sale_name }}</span>
            </p>
          </div>
        </template>
        <template v-else>
          <div class="headerInfo">
            <p class="Sales">
              <span>{{ $t("slack.Sales") }}:</span>
              <span>{{ ObjPopupData.SaleOrderData.customer.sale_name }}</span>
            </p>
            <!-- <p class="Contacts">
              <span>{{ $t("slack.Purchaser") }}:</span>
              <span>{{ ObjPopupData.SaleOrderData.customer.sale_name }}</span>
            </p> -->
          </div>
        </template>
        <div class="itemBox ModelBox">
          <div class="ModelNumDiv">
            <p class="num">
              {{ $t("slack.Models") }} (
              {{
                ObjPopupData.SaleOrderData.list.total >= 10 ||
                  ObjPopupData.SaleOrderData.list.total == 0
                  ? ObjPopupData.SaleOrderData.list.total
                  : "0" + ObjPopupData.SaleOrderData.list.total
              }}
              )
            </p>
            <div class="CurrentBox flex aic">
              <p>
                {{ ObjPopupData.SaleOrderData.customer.Current }} Rate:{{
                  ObjPopupData.SaleOrderData.customer.Current_rate
                }}
              </p>
              <i class="iconfont icon-xiangxiajixu f16 000" v-if="SaleOrdeInfo.Isexpand"
                @click="SaleOrdeInfo.Isexpand = !SaleOrdeInfo.Isexpand"></i>
              <i class="iconfont icon-xiangxiajixu f16 000" v-else style="transform: rotate(180deg)"
                @click="SaleOrdeInfo.Isexpand = !SaleOrdeInfo.Isexpand"></i>
            </div>
          </div>
          <el-select placeholder="Select" size="small" class="mt-10" @change="GetordersHistory" clearable
            v-if="userInfo.type != 4" v-model="ordersStatus">
            <el-option v-for="item in ordersStatusList" :key="item.code" :label="item.massge" :value="item.code" />
          </el-select>
          <div class="ModelList">
            <div class="Models" v-for="(model, index) in ObjPopupData.SaleOrderData.dataList" :key="index">
              <!-- <div class="stateBox">
                <p>
                  <span style="color: red; position: relative; top: 3px">*</span>
                  <span class="state_text">
                    {{
                    ObjPopupData.SaleOrderData.dataList[index][0].state_text
                    }}
                  </span>
                </p>
                <el-icon @click="copyClick('SaleOrder')">
                  <CopyDocument />
                </el-icon>
              </div>-->
              <!-- <div class="Model" v-for="(model, index) in item" :key="index"> -->
              <div class="modelDiv">
                <div class="ModelName flex aic">
                  <el-tooltip class="box-item" effect="dark" :content="model.product_name_pi + '*' + model.quantity"
                    :disabled="isShowTooltip" placement="bottom">
                    <p style="width: calc(100% - 95px)" @mouseenter="getWidth($event)">
                      {{ model.product_name_pi }} * {{ model.quantity }}
                    </p>
                  </el-tooltip>
                  <p style="color: #f55523; width: 90px" class="flex aic ml-5">
                    <i :class="[
                      getCurrencyIcon(
                        ObjPopupData.SaleOrderData.customer.Current
                      ),
                      'iconfont f14',
                    ]"></i>
                    <span class="ml-5">{{ model.price }}</span>
                  </p>
                </div>
              </div>
              <div class="infoDiv" v-if="SaleOrdeInfo.Isexpand">
                <p>{{ $t("slack.Brand") }}: {{ model.Brand_name }}</p>
                <p>
                  {{ $t("slack.Condition") }}: {{ model.product_condition }}
                </p>
                <p>{{ $t("slack.Leading") }}: {{ model.leadingtime }}</p>
                <p>
                  {{ $t("slack.Cost") }}:
                  <i :class="[getCurrencyIcon('CNY'), 'iconfont f14']" v-if="model.cost"></i>
                  <span>{{ model.cost || "-" }}</span>
                </p>
              </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div class="itemBox FeeBox">
          <p class="infoTitle">{{ $t("slack.Fee") }}</p>
          <div class="FeeData">
            <div>
              <span>{{ $t("slack.Discount") }}:</span>
              <p class="flex aic">
                <i :class="[
                  getCurrencyIcon(
                    ObjPopupData.SaleOrderData.customer.Current
                  ),
                  'iconfont f14',
                ]"></i>
                <span class="ml-5">{{
                  ObjPopupData.SaleOrderData.customer.discount_value
                }}</span>
              </p>
            </div>
            <div>
              <span>{{ $t("slack.PaymentFee") }}:</span>
              <p class="flex aic">
                <i :class="[
                  getCurrencyIcon(
                    ObjPopupData.SaleOrderData.customer.Current
                  ),
                  'iconfont f14',
                ]"></i>
                <span class="ml-5">{{
                  ObjPopupData.SaleOrderData.customer.Payment_charge
                }}</span>
              </p>
            </div>
            <div>
              <span>{{ $t("slack.ShippingCost") }}:</span>
              <p class="flex aic">
                <i :class="[
                  getCurrencyIcon(
                    ObjPopupData.SaleOrderData.customer.Current
                  ),
                  'iconfont f14',
                ]"></i>
                <span class="ml-5">{{
                  ObjPopupData.SaleOrderData.customer.Shipping_cost
                }}</span>
              </p>
            </div>
            <div>
              <span>{{ $t("slack.Tax") }}:</span>
              <p class="flex aic">
                <i :class="[
                  getCurrencyIcon(
                    ObjPopupData.SaleOrderData.customer.Current
                  ),
                  'iconfont f14',
                ]"></i>
                <span class="ml-5">{{
                  ObjPopupData.SaleOrderData.customer.Invoice_shipping_cost
                }}</span>
              </p>
            </div>

            <div>
              <span>{{ $t("slack.SubTotal") }}:</span>
              <p class="flex aic">
                <i :class="[
                  getCurrencyIcon(
                    ObjPopupData.SaleOrderData.customer.Current
                  ),
                  'iconfont f14',
                ]"></i>
                <span class="ml-5">{{
                  ObjPopupData.SaleOrderData.SubTotal
                }}</span>
              </p>
            </div>
            <div style="font-weight: 700">
              <span>{{ $t("slack.GrandTotal") }}:</span>
              <p class="flex aic">
                <i :class="[
                  getCurrencyIcon(
                    ObjPopupData.SaleOrderData.customer.Current
                  ),
                  'iconfont f14',
                ]"></i>
                <span class="ml-5">{{
                  ObjPopupData.SaleOrderData.GrandTotal
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="itemBox DetailsBox">
          <p class="infoTitle">{{ $t("slack.Details") }}</p>
          <p style="margin-bottom: 5px">
            {{ $t("slack.Type") }}:
            {{ ObjPopupData.SaleOrderData.customer.orderType_text }}
          </p>
          <p>
            {{ $t("slack.Payment") }}:
            {{ ObjPopupData.SaleOrderData.payment.config_name }}
            {{ ObjPopupData.SaleOrderData.payment.config_short }}
          </p>
          <div class="BankBox">
            <el-tooltip effect="dark" :content="'<p>' + ObjPopupData.SaleOrderData.payment.config_value + '</p>'
              " placement="top" raw-content>
              <p @mouseenter="getWidth($event)">
                {{ ObjPopupData.SaleOrderData.payment.config_value || "-" }}
              </p>
            </el-tooltip>
          </div>
          <!-- <p>
            <el-tooltip
              effect="dark"
              :content="ObjPopupData.SaleOrderData.CustomerName6"
              placement="bottom"
              :disabled="isShowTooltip"
            >
              <p @mouseenter="getWidth($event)">
                {{ $t("slack.Contacts") }}:
                {{ ObjPopupData.SaleOrderData.CustomerName6 || "-" }}
              </p>
            </el-tooltip>
          </p>
          <div class="ContactsBox">
            <i class="iconfont icon-dizhi f555"></i>
            <span>{{ $t("slack.Address") }}:</span>
            <el-tooltip
              effect="dark"
              :content="ObjPopupData.SaleOrderData.customer.address.address"
              :disabled="isShowTooltip"
              placement="top"
              v-if="ObjPopupData.SaleOrderData.customer.address"
            >
              <p
                class="addressTxt"
                @mouseenter="getWidth($event)"
              >{{ ObjPopupData.SaleOrderData.customer.address.address }}</p>
            </el-tooltip>
          </div>-->
          <template v-if="
            userInfo.type == 1 ||
            userInfo.type == 6 ||
            ObjPopupData.SaleOrderData.customer.create_user_id ==
            userInfo.user_uid ||
            ObjPopupData.SaleOrderData.customer.Sales_User_ID ==
            userInfo.user_uid
          ">
            <div v-if="userInfo.type != 4">
              <p>
                {{ $t("slack.Vendor") }}:
                {{ ObjPopupData.SaleOrderData.company.CompanyName }}
              </p>
              <div class="ContactsBox">
                <i class="iconfont icon-dizhi f555"></i>
                <span>{{ $t("slack.Address") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.SaleOrderData.company.address"
                  :disabled="isShowTooltip" placement="top">
                  <p class="addressTxt" @mouseenter="getWidth($event)">
                    {{ ObjPopupData.SaleOrderData.company.address }}
                  </p>
                </el-tooltip>
              </div>
            </div>
            <!-- <div v-if="userInfo.type == 4">
              <p>
                {{ $t("slack.Purchaser") }}:
                {{ ObjPopupData.SaleOrderData.CustomerName6 }}
              </p>
              <div class="ContactsBox">
                <i class="iconfont icon-dizhi f555"></i>
                <span>{{ $t("slack.Address") }}:</span>
                <el-tooltip
                  effect="dark"
                  :content="ObjPopupData.SaleOrderData.customer.address.address"
                  :disabled="isShowTooltip"
                  placement="top"
                >
                  <p class="addressTxt" @mouseenter="getWidth($event)">
                    {{ ObjPopupData.SaleOrderData.customer.address.address }}
                  </p>
                </el-tooltip>
              </div>
            </div> -->
          </template>
          <template v-else>
            <div>
              <p>
                {{ $t("slack.Vendor") }}:
                {{ ObjPopupData.SaleOrderData.company.CompanyName }}
              </p>
              <div class="ContactsBox">
                <i class="iconfont icon-dizhi f555"></i>
                <span>{{ $t("slack.Address") }}:</span>
                <el-tooltip effect="dark" :content="ObjPopupData.SaleOrderData.company.address"
                  :disabled="isShowTooltip" placement="top">
                  <p class="addressTxt" @mouseenter="getWidth($event)">
                    {{ ObjPopupData.SaleOrderData.company.address }}
                  </p>
                </el-tooltip>
              </div>
            </div>
          </template>
          <p class="bottomInfo">
            {{ $t("slack.CreatedBy") }}
            {{ ObjPopupData.SaleOrderData.customer.create_user }},
            {{ getTime(ObjPopupData.SaleOrderData.customer.CreateTime, "/") }}
          </p>
        </div>
        <div class="itemBox" v-if="Number(ObjPopupData.SaleOrderData.PurchaseOrderteskNum)" @click="
          getPurchaseTasks(ObjPopupData.SaleOrderData.PurchaseOrderteskNum)
          ">
          <p class="infoTitle">
            <span>{{ $t("slack.PurchaseTasks") }}</span>
            <span style="color: #3370ff; margin-left: 5px">{{
              ObjPopupData.SaleOrderData.PurchaseOrderteskNum
            }}</span>
          </p>
        </div>
        <div class="itemBox" v-if="Number(ObjPopupData.SaleOrderData.PurchaseOrderNum)" @click="
          getPurchaseOrders(ObjPopupData.SaleOrderData.PurchaseOrderNum)
          ">
          <p class="infoTitle">
            <span>{{ $t("slack.PurchaseOrders") }}</span>
            <span style="color: #3370ff; margin-left: 5px">{{
              ObjPopupData.SaleOrderData.PurchaseOrderNum
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 查看采购订单详情 -->
    <div class="PurchaseOrderBox detailBox" v-if="ObjPopupData.type == 'PurchaseOrder'">
      <div class="flexpane_header">
        <div class="flex aic jc-c" @click="Closedetail">
          <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path
                d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                id="left__a" />
            </defs>
            <use xlink:href="#left__a" fill-rule="evenodd" />
          </svg>
        </div>
        <div class="flexpane__subtitle">
          {{ $t("slack.PurchaseOrderID") }} :
          {{ ObjPopupData.PurchaseOrderData.Purchaseordername }}
        </div>
      </div>
      <div class="detail_body">
        <div class="headerInfo" v-if="userInfo.type != 4">
          <p class="Sales">
            <span>{{ $t("slack.Sales") }}:</span>
            <span v-if="ObjPopupData.PurchaseOrderData.sale">{{
              ObjPopupData.PurchaseOrderData.sale.join(",")
            }}</span>
            <span v-else>-</span>
          </p>
          <p class="Contacts">
            <span>{{ $t("slack.Purchaser") }}:</span>
            <span>{{ ObjPopupData.PurchaseOrderData.create_name }}</span>
          </p>
          <p class="Contacts">
            <span>{{ $t("slack.Vendor") }}:</span>
            <span style="color: #3370ff">{{
              ObjPopupData.PurchaseOrderData.Contacts
            }}</span>
          </p>
        </div>
        <div class="headerInfo" v-if="userInfo.type == 4">
          <p class="Sales">
            <span>{{ $t("slack.Sales") }}:</span>
            <span>{{ ObjPopupData.PurchaseOrderData.sale }}</span>
          </p>
          <p class="Contacts">
            <span>{{ $t("slack.Purchaser") }}:</span>
            <span>{{ ObjPopupData.PurchaseOrderData.Contacts || "-" }}</span>
          </p>
          <p class="Contacts">
            <span>{{ $t("slack.Vendor") }}:</span>
            <span style="color: #3370ff">{{
              ObjPopupData.PurchaseOrderData.CompanyName
            }}</span>
          </p>
        </div>
        <div class="itemBox ModelBox">
          <div class="ModelNumDiv">
            <p class="num">
              {{ $t("slack.Models") }} (
              {{
                ObjPopupData.PurchaseOrderData.total >= 10 ||
                  ObjPopupData.PurchaseOrderData.total == 0
                  ? ObjPopupData.PurchaseOrderData.total
                  : "0" + ObjPopupData.PurchaseOrderData.total
              }}
              )
            </p>
            <div class="CurrentBox flex aic">
              <i class="iconfont icon-xiangxiajixu f16 000" v-if="SaleOrdeInfo.Isexpand"
                @click="SaleOrdeInfo.Isexpand = !SaleOrdeInfo.Isexpand"></i>
              <i class="iconfont icon-xiangxiajixu f16 000" v-else style="transform: rotate(180deg)"
                @click="SaleOrdeInfo.Isexpand = !SaleOrdeInfo.Isexpand"></i>
            </div>
          </div>
          <div class="ModelList">
            <div class="Models">
              <div class="Model" v-for="(model, index) in ObjPopupData.PurchaseOrderData.data" :key="index">
                <div class="modelDiv">
                  <el-tooltip class="box-item" effect="dark" :content="model.Model + '*' + model.dty"
                    :disabled="isShowTooltip" placement="bottom">
                    <p @mouseenter="getWidth($event)" class="ModelName" :class="{ NoBottom: index == 0 }">
                      {{ model.Model }} * {{ model.dty }}
                    </p>
                  </el-tooltip>
                  <p style="color: #f55523" class="flex aic">
                    <i :class="[
                      getCurrencyIcon(model.sale_current),
                      'iconfont f14',
                    ]"></i>
                    <span class="ml-5">{{ (model.cost * model.dty).toFixed(2) }}</span>
                  </p>
                </div>
                <div class="infoDiv" v-if="SaleOrdeInfo.Isexpand">
                  <p>{{ $t("slack.Brand") }}: {{ model.Brand_name }}</p>

                  <p>
                    {{ $t("slack.Condition") }}: {{ model.product_condition }}
                  </p>
                  <p>{{ $t("slack.Leading") }}: {{ model.Leading_name }}</p>
                  <p>
                    {{ $t("slack.Cost") }}:
                    <i :class="[
                      getCurrencyIcon(model.purchase_current),
                      'iconfont f14',
                    ]"></i>
                    <span>{{ model.cost }}</span>
                  </p>
                  <p v-if="userInfo.type != 4">
                    {{ $t("slack.Profit") }}: {{ model.Profit }}%
                  </p>
                </div>
              </div>
            </div>
          </div>
          <p class="bottomInfo" style="font-size: 16px; color: #555555; margin-top: 15px">
            {{ $t("slack.CreatedBy") }}
            {{ ObjPopupData.PurchaseOrderData.create_name }},
            {{ getTime(ObjPopupData.PurchaseOrderData.create_time, "/") }}
          </p>
        </div>
        <div v-if="ObjPopupData.PurchaseOrderData.PurchaseOrderteskNum" class="itemBox" @click="
          getPurchaseTasks1(
            ObjPopupData.PurchaseOrderData.PurchaseOrderteskNum
          )
          ">
          <p class="infoTitle">
            <span>{{ $t("slack.PurchaseTasks") }}</span>
            <span style="color: #3370ff; margin-left: 5px">{{
              ObjPopupData.PurchaseOrderData.PurchaseOrderteskNum
            }}</span>
          </p>
        </div>
        <template v-if="
          userInfo.type == 1 ||
          userInfo.type == 2 ||
          userInfo.type == 16 ||
          userInfo.type == 6 ||
          userInfo.type == 7 ||
          ObjPopupData.PurchaseOrderData.create_user == userInfo.user_uid
        ">
          <div class="itemBox" @click="getRelatedSaleOrder" v-if="userInfo.type != 3">
            <p class="infoTitle">{{ $t("slack.RelatedSalesOrder") }}</p>
          </div>
        </template>
      </div>
    </div>
    <!-- 运输详情 -->
    <shipDetail v-if="ObjPopupData.type && ObjPopupData.type.indexOf('Ship') != -1" />
    <!-- 查看联系人详情 -->
    <div class="ContactsDetailsBox detailBox" v-if="ObjPopupData.type == 'Contacts'">
      <div class="flexpane_header">
        <div class="flex aic jc-c" @click="Closedetail">
          <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path
                d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                id="left__a" />
            </defs>
            <use xlink:href="#left__a" fill-rule="evenodd" />
          </svg>
        </div>
        <div class="flexpane__subtitle">{{ $t("slack.ContactDetails") }}</div>
      </div>
      <div class="detail_body">
        <div class="itemBox">
          <div class="ContactsName">
            <svg t="1688000707385" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="5794" width="56" height="56">
              <path
                d="M310.956564 662.25202zM307.071733 652.841638zM303.914275 643.972652c0.219038 0.669513 0.471139 1.326628 0.69431 1.992009-0.231437-0.661248-0.471139-1.322495-0.69431-1.992009zM539.239951 781.611372a3.0872 3.0872 0 0 0 0.962942-0.181843c-0.698443 0.086789-1.401019 0.136382-2.103594 0.219038l1.140652-0.037195zM315.841531 672.418704zM292.044878 564.370822a1501.734968 1501.734968 0 0 0-0.169445-17.436277c-0.02893 5.926433 0.02893 11.737148 0.169445 17.436277zM729.39414 534.32951c-0.169445 10.910588-0.376085 22.056745-0.376085 33.368215 0 21.507083-2.49621 41.373445-7.021624 59.661078 7.401842-28.264209 9.476507-58.218732 7.397709-93.029293z"
                fill="#002738" p-id="5795" />
              <path
                d="M507.843081 8.435042c-280.451702 0-507.838272 227.266719-507.838272 507.722553 0 187.54226 101.608982 351.250672 252.745422 439.200756 0.421545-1.169582 0.818294-2.359828 1.25637-3.52941 16.915544-45.564103 44.76234-81.97819 79.184418-109.176136 22.445228-17.886752 48.200828-32.198633 76.609685-42.39838-58.995698-51.403747-60.739739-65.430465-40.489026-63.53351a193.757989 193.757989 0 0 1-47.122168-53.015538c0.396749 0.648849 0.739771 1.310097 1.144785 1.963079-193.113273-186.203234-50.234165-534.188995 184.508786-411.072929l0.23557 0.115718c161.344451-84.825688 283.667019 58.342716 280.381444 212.863916-0.938145 70.860962-28.115428 143.685003-89.785046 196.799729 0.442209-0.789365 0.830692-1.582862 1.268769-2.368093-13.46879 22.879172-31.000121 41.844584-51.180576 56.966493 10.183215 3.32277 5.996691 19.816769-28.22288 61.500174h-0.264499c27.788937 10.046833 53.019671 24.02809 75.084682 41.456101 34.029462 26.623488 61.73161 62.17382 78.911653 106.630332 144.858718-89.433758 241.413288-249.592096 241.413288-432.406435-0.004133-280.451702-227.38657-507.718421-507.842405-507.71842z"
                fill="#002738" p-id="5796" />
              <path
                d="M538.103431 781.648567c0.702576-0.082656 1.405151-0.13225 2.103595-0.219038 10.551034-3.149192 88.218715-49.08938 108.560349-42.452106 20.180455-15.121909 37.711786-34.087322 51.180576-56.966494 9.943513-18.072728 17.167645-36.000807 22.052612-54.652126 4.529547-18.287633 7.021625-38.149862 7.021625-59.661078 0-11.311469 0.20664-22.46176 0.376085-33.368215-0.793497-13.369603-2.18625-27.445914-4.1204-42.423176-95.711479 5.856175-163.658818-27.883991-217.426526-82.002987-75.208666 51.312825-146.904453 80.949123-214.029366 82.002987-1.074528 19.498543-1.843228 37.761379-1.938282 55.028211 0.086789 5.740457 0.152914 11.555304 0.169445 17.436277 0.739771 29.082503 3.979885 55.276179 11.865264 79.605963 0.227304 0.669513 0.462873 1.326628 0.69431 1.992009 0.776966 2.310234 1.603526 4.595672 2.467281 6.872844 1.103457 2.851631 2.248242 5.661934 3.459152 8.422643 0.144648 0.326491 0.276897 0.661248 0.425678 0.987739 1.330761 2.98388 2.73178 5.901636 4.186525 8.773931 0.23557 0.462873 0.462873 0.934012 0.698443 1.392753 1.186113 2.297836 2.434218 4.53368 3.694722 6.757126 0.867888 1.512604 1.731643 3.029341 2.653256 4.533679a193.757989 193.757989 0 0 0 47.122168 53.015539c31.421667 2.93842 115.805145 44.21681 121.429884 43.716742 19.167919 2.52514 28.243545 1.789502 47.353604 1.206777zM695.356412 841.933698c35.033732 27.66082 62.062234 63.967454 78.804201 106.692324l0.10332-0.066125c-17.17591-44.45238-44.873925-80.002712-78.907521-106.626199zM333.191019 842.656937c-34.422078 27.197947-62.264741 63.612034-79.184418 109.176137 16.485733-43.753937 43.708476-80.907795 79.184418-109.176137z"
                fill="#FCE9EA" p-id="5797" />
              <path
                d="M695.356412 841.933698c-22.065011-17.428011-47.295745-31.413401-75.084682-41.456101l-210.363573-0.119852-0.107453-0.095054c-28.408856 10.199747-54.164456 24.511628-76.609685 42.398379-35.471809 28.272474-62.698685 65.422199-79.184418 109.176136-0.438077 1.165449-0.834825 2.355695-1.25637 3.52941 74.964831 43.629953 162.104886 68.633384 255.09285 68.633384 97.670425 0 188.88542-27.590562 266.317532-75.365712-16.741966-42.737269-43.770468-79.03977-78.804201-106.70059z"
                fill="#B0C11D" p-id="5798" />
              <path
                d="M620.27173 800.473464h0.264499c34.219571-41.683405 38.406096-58.177404 28.222881-61.500174-20.341634-6.633141-98.009315 39.307046-108.56035 42.452106a3.124396 3.124396 0 0 1-0.962942 0.181843l-1.136519 0.037195c-19.11006 0.586857-28.181553 1.318363-47.36187-1.206777-5.624739 0.500069-90.008217-40.778322-121.429884-43.716742-20.250712-1.896954-18.510804 12.133896 40.489026 63.53351l0.107453 0.095055 210.367706 0.123984z"
                fill="#FF5947" p-id="5799" />
              <path
                d="M315.841531 672.418704c-0.239702-0.458741-0.462873-0.92988-0.698442-1.392753a180.789268 180.789268 0 0 1-4.186525-8.773931l-0.425679-0.987739a184.876605 184.876605 0 0 1-5.926432-15.295487c-0.223171-0.665381-0.475272-1.322495-0.694311-1.992009-7.885379-24.329784-11.125493-50.523461-11.865264-79.605963a563.192974 563.192974 0 0 1-0.169445-17.436277c0.095054-17.266832 0.859622-35.529668 1.938283-55.028211 67.124912-1.053864 138.8207-30.694294 214.029365-82.002987v-135.30782c-234.742951-123.116065-377.622059 224.869696-184.508786 411.072929-0.409147-0.648849-0.748037-1.310097-1.144785-1.963079-0.921614-1.500206-1.785369-3.016943-2.653257-4.53368-1.281168-2.235844-2.521007-4.488219-3.694722-6.752993zM698.675049 684.379023c61.669618-53.118858 88.846901-125.938767 89.785046-196.799729-1.49194 69.976543-28.727082 142.279852-89.785046 196.799729z"
                fill="#FECF77" p-id="5800" />
              <path
                d="M507.843081 409.903347c53.77184 54.123128 121.715047 87.863295 217.426526 82.002987 1.93415 14.977262 3.326903 29.053573 4.1204 42.423176 2.078798 34.810561 0.004133 64.765084-7.397709 93.029293-4.884968 18.651319-12.109099 36.579399-22.052613 54.652126-0.433944 0.785232-0.822427 1.578729-1.268769 2.368094 61.053831-54.515744 88.293106-126.823186 89.785046-196.799729 3.285575-154.525334-119.036993-297.689604-280.381444-212.863916l-0.23557-0.115719v135.303688z"
                fill="#FF9F31" p-id="5801" />
            </svg>
            <p class="Owner">
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.CustomerName6" :disabled="isShowTooltip"
                placement="bottom">
                <strong style="color: #000; font-size: 16px; margin: 5px 0" @mouseenter="getWidth($event)">{{
                  ObjPopupData.ContactsData.CustomerName6 || "-" }}</strong>
              </el-tooltip>

              <span style="white-space: pre-wrap">
                {{ $t("slack.Owner") }}:
                {{ ObjPopupData.ContactsData.owner_names }}
              </span>
            </p>
          </div>
          <div class="infoBox">
            <p>
              <span>{{ $t("slack.name") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.CustomerName6 || '-'"
                :disabled="isShowTooltip" placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.CustomerName6 || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.Type") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.RetailWholsale || '-'"
                :disabled="isShowTooltip" placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.RetailWholsale || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.Level") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.customer_info_grade || '-'"
                :disabled="isShowTooltip" placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.customer_info_grade || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.DealStatus") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.Customer_type || '-'"
                :disabled="isShowTooltip" placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.Customer_type || "-" }}
                </span>
              </el-tooltip>
            </p>
            <!-- <p>
              <span>{{ $t("slack.Vendor") }}:</span>
              <el-tooltip
                effect="dark"
                :content="ObjPopupData.ContactsData.Vendor || '-'"
                :disabled="isShowTooltip"
                placement="bottom"
              >
                <span @mouseenter="getWidth($event)">
                  {{
                  ObjPopupData.ContactsData.Vendor || "-"
                  }}
                </span>
              </el-tooltip>
            </p>-->
            <p>
              <span>{{ $t("slack.Email") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.email || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.email || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.Phone") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.telephone || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.telephone || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.OtherPhone") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.otherPhone || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.otherPhone || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.Fax") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.fax || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.fax || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.department") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.department || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.department || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.DateOfBrith") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.birthday || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.birthday || "-" }}
                </span>
              </el-tooltip>
            </p>
          </div>
        </div>
        <div class="itemBox">
          <p class="infoTitle">{{ $t("slack.AddressInformation") }}</p>
          <div class="AddressBox" v-for="(item, index) in ObjPopupData.ContactsData.address" :key="index">
            {{ $t("slack.Address") }} {{ index + 1 }} : {{ item.address }}
          </div>
        </div>
        <div class="itemBox">
          <p class="infoTitle">{{ $t("slack.DescriptionInformation") }}</p>
          <div class="DescriptionBox">
            <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.comments || '-'" placement="bottom"
              popper-class="SlackDescriptionContent" :disabled="isShowTooltip">
              <p @mouseenter="getWidth($event)">
                {{ ObjPopupData.ContactsData.comments || "-" }}
              </p>
            </el-tooltip>
          </div>
        </div>
        <div class="itemBox">
          <p class="infoTitle">{{ $t("slack.RelatedInformation") }}</p>
          <div class="RelatedBox">
            <div class="RelatedItem">
              <div class="IconBox flex aic jc-c" style="background-color: #f59a23">
                <i class="iconfont icon-a-RFQ_huaban1 f20 fff"></i>
              </div>
              <p>
                {{ $t("slack.RFQ") }}
                <strong>{{ ObjPopupData.RelatedRFQCount }}</strong>
              </p>
            </div>
            <div class="RelatedItem">
              <div class="IconBox flex aic jc-c" style="background-color: rgb(236, 136, 128)">
                <i class="iconfont icon-a-QTN_huaban1 f20 fff"></i>
              </div>
              <p>
                {{ $t("slack.QTN") }}
                <strong>{{ ObjPopupData.RelatedQTNCount }}</strong>
              </p>
            </div>
            <div class="RelatedItem">
              <div class="IconBox flex aic jc-c" style="background-color: #76bd55">
                <i class="iconfont icon-a-SalesOrders2_huaban1 f20 fff"></i>
              </div>
              <p>
                {{ $t("slack.Orders") }}
                <strong>{{ ObjPopupData.RelatedOrderCount }}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看供应商详情 -->
    <div class="ContactsDetailsBox detailBox" v-if="ObjPopupData.type == 'Vendor'">
      <div class="flexpane_header">
        <div class="flex aic jc-c" @click="Closedetail">
          <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path
                d="M18.534.414c-.6-.57-1.55-.55-2.122.052l-10.005 10.5c-.019.02-.029.045-.043.068-.033.051-.063.103-.097.154-.055.083-.12.161-.158.251-.036.09-.044.187-.062.281-.018.094-.047.185-.047.28 0 .095.029.186.047.28.018.094.026.191.062.281.037.09.103.168.158.251.034.051.064.103.097.154.014.023.024.048.043.068l10.005 10.5c.295.31.69.466 1.087.466.372 0 .744-.138 1.035-.414.6-.571.624-1.521.052-2.12L9.566 12l9.02-9.466c.572-.599.548-1.549-.052-2.12"
                id="left__a" />
            </defs>
            <use xlink:href="#left__a" fill-rule="evenodd" />
          </svg>
        </div>
        <div class="flexpane__subtitle">{{ $t("slack.VendorDetails") }}</div>
      </div>
      <div class="detail_body">
        <div class="itemBox">
          <div class="ContactsName">
            <svg t="1688000707385" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="5794" width="56" height="56">
              <path
                d="M310.956564 662.25202zM307.071733 652.841638zM303.914275 643.972652c0.219038 0.669513 0.471139 1.326628 0.69431 1.992009-0.231437-0.661248-0.471139-1.322495-0.69431-1.992009zM539.239951 781.611372a3.0872 3.0872 0 0 0 0.962942-0.181843c-0.698443 0.086789-1.401019 0.136382-2.103594 0.219038l1.140652-0.037195zM315.841531 672.418704zM292.044878 564.370822a1501.734968 1501.734968 0 0 0-0.169445-17.436277c-0.02893 5.926433 0.02893 11.737148 0.169445 17.436277zM729.39414 534.32951c-0.169445 10.910588-0.376085 22.056745-0.376085 33.368215 0 21.507083-2.49621 41.373445-7.021624 59.661078 7.401842-28.264209 9.476507-58.218732 7.397709-93.029293z"
                fill="#002738" p-id="5795" />
              <path
                d="M507.843081 8.435042c-280.451702 0-507.838272 227.266719-507.838272 507.722553 0 187.54226 101.608982 351.250672 252.745422 439.200756 0.421545-1.169582 0.818294-2.359828 1.25637-3.52941 16.915544-45.564103 44.76234-81.97819 79.184418-109.176136 22.445228-17.886752 48.200828-32.198633 76.609685-42.39838-58.995698-51.403747-60.739739-65.430465-40.489026-63.53351a193.757989 193.757989 0 0 1-47.122168-53.015538c0.396749 0.648849 0.739771 1.310097 1.144785 1.963079-193.113273-186.203234-50.234165-534.188995 184.508786-411.072929l0.23557 0.115718c161.344451-84.825688 283.667019 58.342716 280.381444 212.863916-0.938145 70.860962-28.115428 143.685003-89.785046 196.799729 0.442209-0.789365 0.830692-1.582862 1.268769-2.368093-13.46879 22.879172-31.000121 41.844584-51.180576 56.966493 10.183215 3.32277 5.996691 19.816769-28.22288 61.500174h-0.264499c27.788937 10.046833 53.019671 24.02809 75.084682 41.456101 34.029462 26.623488 61.73161 62.17382 78.911653 106.630332 144.858718-89.433758 241.413288-249.592096 241.413288-432.406435-0.004133-280.451702-227.38657-507.718421-507.842405-507.71842z"
                fill="#002738" p-id="5796" />
              <path
                d="M538.103431 781.648567c0.702576-0.082656 1.405151-0.13225 2.103595-0.219038 10.551034-3.149192 88.218715-49.08938 108.560349-42.452106 20.180455-15.121909 37.711786-34.087322 51.180576-56.966494 9.943513-18.072728 17.167645-36.000807 22.052612-54.652126 4.529547-18.287633 7.021625-38.149862 7.021625-59.661078 0-11.311469 0.20664-22.46176 0.376085-33.368215-0.793497-13.369603-2.18625-27.445914-4.1204-42.423176-95.711479 5.856175-163.658818-27.883991-217.426526-82.002987-75.208666 51.312825-146.904453 80.949123-214.029366 82.002987-1.074528 19.498543-1.843228 37.761379-1.938282 55.028211 0.086789 5.740457 0.152914 11.555304 0.169445 17.436277 0.739771 29.082503 3.979885 55.276179 11.865264 79.605963 0.227304 0.669513 0.462873 1.326628 0.69431 1.992009 0.776966 2.310234 1.603526 4.595672 2.467281 6.872844 1.103457 2.851631 2.248242 5.661934 3.459152 8.422643 0.144648 0.326491 0.276897 0.661248 0.425678 0.987739 1.330761 2.98388 2.73178 5.901636 4.186525 8.773931 0.23557 0.462873 0.462873 0.934012 0.698443 1.392753 1.186113 2.297836 2.434218 4.53368 3.694722 6.757126 0.867888 1.512604 1.731643 3.029341 2.653256 4.533679a193.757989 193.757989 0 0 0 47.122168 53.015539c31.421667 2.93842 115.805145 44.21681 121.429884 43.716742 19.167919 2.52514 28.243545 1.789502 47.353604 1.206777zM695.356412 841.933698c35.033732 27.66082 62.062234 63.967454 78.804201 106.692324l0.10332-0.066125c-17.17591-44.45238-44.873925-80.002712-78.907521-106.626199zM333.191019 842.656937c-34.422078 27.197947-62.264741 63.612034-79.184418 109.176137 16.485733-43.753937 43.708476-80.907795 79.184418-109.176137z"
                fill="#FCE9EA" p-id="5797" />
              <path
                d="M695.356412 841.933698c-22.065011-17.428011-47.295745-31.413401-75.084682-41.456101l-210.363573-0.119852-0.107453-0.095054c-28.408856 10.199747-54.164456 24.511628-76.609685 42.398379-35.471809 28.272474-62.698685 65.422199-79.184418 109.176136-0.438077 1.165449-0.834825 2.355695-1.25637 3.52941 74.964831 43.629953 162.104886 68.633384 255.09285 68.633384 97.670425 0 188.88542-27.590562 266.317532-75.365712-16.741966-42.737269-43.770468-79.03977-78.804201-106.70059z"
                fill="#B0C11D" p-id="5798" />
              <path
                d="M620.27173 800.473464h0.264499c34.219571-41.683405 38.406096-58.177404 28.222881-61.500174-20.341634-6.633141-98.009315 39.307046-108.56035 42.452106a3.124396 3.124396 0 0 1-0.962942 0.181843l-1.136519 0.037195c-19.11006 0.586857-28.181553 1.318363-47.36187-1.206777-5.624739 0.500069-90.008217-40.778322-121.429884-43.716742-20.250712-1.896954-18.510804 12.133896 40.489026 63.53351l0.107453 0.095055 210.367706 0.123984z"
                fill="#FF5947" p-id="5799" />
              <path
                d="M315.841531 672.418704c-0.239702-0.458741-0.462873-0.92988-0.698442-1.392753a180.789268 180.789268 0 0 1-4.186525-8.773931l-0.425679-0.987739a184.876605 184.876605 0 0 1-5.926432-15.295487c-0.223171-0.665381-0.475272-1.322495-0.694311-1.992009-7.885379-24.329784-11.125493-50.523461-11.865264-79.605963a563.192974 563.192974 0 0 1-0.169445-17.436277c0.095054-17.266832 0.859622-35.529668 1.938283-55.028211 67.124912-1.053864 138.8207-30.694294 214.029365-82.002987v-135.30782c-234.742951-123.116065-377.622059 224.869696-184.508786 411.072929-0.409147-0.648849-0.748037-1.310097-1.144785-1.963079-0.921614-1.500206-1.785369-3.016943-2.653257-4.53368-1.281168-2.235844-2.521007-4.488219-3.694722-6.752993zM698.675049 684.379023c61.669618-53.118858 88.846901-125.938767 89.785046-196.799729-1.49194 69.976543-28.727082 142.279852-89.785046 196.799729z"
                fill="#FECF77" p-id="5800" />
              <path
                d="M507.843081 409.903347c53.77184 54.123128 121.715047 87.863295 217.426526 82.002987 1.93415 14.977262 3.326903 29.053573 4.1204 42.423176 2.078798 34.810561 0.004133 64.765084-7.397709 93.029293-4.884968 18.651319-12.109099 36.579399-22.052613 54.652126-0.433944 0.785232-0.822427 1.578729-1.268769 2.368094 61.053831-54.515744 88.293106-126.823186 89.785046-196.799729 3.285575-154.525334-119.036993-297.689604-280.381444-212.863916l-0.23557-0.115719v135.303688z"
                fill="#FF9F31" p-id="5801" />
            </svg>
            <p class="Owner">
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.CompanyName" :disabled="isShowTooltip"
                placement="bottom">
                <strong style="color: #000; font-size: 16px; margin: 5px 0" @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.CompanyName || "-" }}
                </strong>
              </el-tooltip>

              <span style="white-space: pre-wrap">
                {{ $t("slack.Owner") }}:
                {{ ObjPopupData.ContactsData.created_name }}
              </span>
            </p>
          </div>
          <div class="infoBox">
            <p>
              <span>{{ $t("slack.Type") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.sell_type || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.sell_type || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.DealStatus") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.deal_state || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.deal_state || "-" }}
                </span>
              </el-tooltip>
            </p>
            <!-- <p>
              <span>{{ $t("slack.Vendor") }}:</span>
              <el-tooltip
                effect="dark"
                :content="ObjPopupData.ContactsData.CompanyName || '-'"
                :disabled="isShowTooltip"
                placement="bottom"
              >
                <span @mouseenter="getWidth($event)">
                  {{
                  ObjPopupData.ContactsData.CompanyName || "-"
                  }}
                </span>
              </el-tooltip>
            </p>-->
            <p>
              <span>{{ $t("slack.Fax") }}:</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.fax || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.fax || "-" }}
                </span>
              </el-tooltip>
            </p>
            <p>
              <span>{{ $t("slack.Website") }} :</span>
              <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.Website || '-'" :disabled="isShowTooltip"
                placement="bottom">
                <span @mouseenter="getWidth($event)">
                  {{ ObjPopupData.ContactsData.Website || "-" }}
                </span>
              </el-tooltip>
            </p>
          </div>
        </div>
        <div class="itemBox">
          <!-- <p class="infoTitle">{{ $t("slack.VendorContacts") }}</p> -->
          <div class="VendorContacts">
            <div class="VendorContactsItem" v-for="(item, index) in ObjPopupData.ContactsData.arrCustomerInfo"
              :key="index">
              <svg t="1688000707385" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5794" width="30" height="30">
                <path
                  d="M310.956564 662.25202zM307.071733 652.841638zM303.914275 643.972652c0.219038 0.669513 0.471139 1.326628 0.69431 1.992009-0.231437-0.661248-0.471139-1.322495-0.69431-1.992009zM539.239951 781.611372a3.0872 3.0872 0 0 0 0.962942-0.181843c-0.698443 0.086789-1.401019 0.136382-2.103594 0.219038l1.140652-0.037195zM315.841531 672.418704zM292.044878 564.370822a1501.734968 1501.734968 0 0 0-0.169445-17.436277c-0.02893 5.926433 0.02893 11.737148 0.169445 17.436277zM729.39414 534.32951c-0.169445 10.910588-0.376085 22.056745-0.376085 33.368215 0 21.507083-2.49621 41.373445-7.021624 59.661078 7.401842-28.264209 9.476507-58.218732 7.397709-93.029293z"
                  fill="#002738" p-id="5795" />
                <path
                  d="M507.843081 8.435042c-280.451702 0-507.838272 227.266719-507.838272 507.722553 0 187.54226 101.608982 351.250672 252.745422 439.200756 0.421545-1.169582 0.818294-2.359828 1.25637-3.52941 16.915544-45.564103 44.76234-81.97819 79.184418-109.176136 22.445228-17.886752 48.200828-32.198633 76.609685-42.39838-58.995698-51.403747-60.739739-65.430465-40.489026-63.53351a193.757989 193.757989 0 0 1-47.122168-53.015538c0.396749 0.648849 0.739771 1.310097 1.144785 1.963079-193.113273-186.203234-50.234165-534.188995 184.508786-411.072929l0.23557 0.115718c161.344451-84.825688 283.667019 58.342716 280.381444 212.863916-0.938145 70.860962-28.115428 143.685003-89.785046 196.799729 0.442209-0.789365 0.830692-1.582862 1.268769-2.368093-13.46879 22.879172-31.000121 41.844584-51.180576 56.966493 10.183215 3.32277 5.996691 19.816769-28.22288 61.500174h-0.264499c27.788937 10.046833 53.019671 24.02809 75.084682 41.456101 34.029462 26.623488 61.73161 62.17382 78.911653 106.630332 144.858718-89.433758 241.413288-249.592096 241.413288-432.406435-0.004133-280.451702-227.38657-507.718421-507.842405-507.71842z"
                  fill="#002738" p-id="5796" />
                <path
                  d="M538.103431 781.648567c0.702576-0.082656 1.405151-0.13225 2.103595-0.219038 10.551034-3.149192 88.218715-49.08938 108.560349-42.452106 20.180455-15.121909 37.711786-34.087322 51.180576-56.966494 9.943513-18.072728 17.167645-36.000807 22.052612-54.652126 4.529547-18.287633 7.021625-38.149862 7.021625-59.661078 0-11.311469 0.20664-22.46176 0.376085-33.368215-0.793497-13.369603-2.18625-27.445914-4.1204-42.423176-95.711479 5.856175-163.658818-27.883991-217.426526-82.002987-75.208666 51.312825-146.904453 80.949123-214.029366 82.002987-1.074528 19.498543-1.843228 37.761379-1.938282 55.028211 0.086789 5.740457 0.152914 11.555304 0.169445 17.436277 0.739771 29.082503 3.979885 55.276179 11.865264 79.605963 0.227304 0.669513 0.462873 1.326628 0.69431 1.992009 0.776966 2.310234 1.603526 4.595672 2.467281 6.872844 1.103457 2.851631 2.248242 5.661934 3.459152 8.422643 0.144648 0.326491 0.276897 0.661248 0.425678 0.987739 1.330761 2.98388 2.73178 5.901636 4.186525 8.773931 0.23557 0.462873 0.462873 0.934012 0.698443 1.392753 1.186113 2.297836 2.434218 4.53368 3.694722 6.757126 0.867888 1.512604 1.731643 3.029341 2.653256 4.533679a193.757989 193.757989 0 0 0 47.122168 53.015539c31.421667 2.93842 115.805145 44.21681 121.429884 43.716742 19.167919 2.52514 28.243545 1.789502 47.353604 1.206777zM695.356412 841.933698c35.033732 27.66082 62.062234 63.967454 78.804201 106.692324l0.10332-0.066125c-17.17591-44.45238-44.873925-80.002712-78.907521-106.626199zM333.191019 842.656937c-34.422078 27.197947-62.264741 63.612034-79.184418 109.176137 16.485733-43.753937 43.708476-80.907795 79.184418-109.176137z"
                  fill="#FCE9EA" p-id="5797" />
                <path
                  d="M695.356412 841.933698c-22.065011-17.428011-47.295745-31.413401-75.084682-41.456101l-210.363573-0.119852-0.107453-0.095054c-28.408856 10.199747-54.164456 24.511628-76.609685 42.398379-35.471809 28.272474-62.698685 65.422199-79.184418 109.176136-0.438077 1.165449-0.834825 2.355695-1.25637 3.52941 74.964831 43.629953 162.104886 68.633384 255.09285 68.633384 97.670425 0 188.88542-27.590562 266.317532-75.365712-16.741966-42.737269-43.770468-79.03977-78.804201-106.70059z"
                  fill="#B0C11D" p-id="5798" />
                <path
                  d="M620.27173 800.473464h0.264499c34.219571-41.683405 38.406096-58.177404 28.222881-61.500174-20.341634-6.633141-98.009315 39.307046-108.56035 42.452106a3.124396 3.124396 0 0 1-0.962942 0.181843l-1.136519 0.037195c-19.11006 0.586857-28.181553 1.318363-47.36187-1.206777-5.624739 0.500069-90.008217-40.778322-121.429884-43.716742-20.250712-1.896954-18.510804 12.133896 40.489026 63.53351l0.107453 0.095055 210.367706 0.123984z"
                  fill="#FF5947" p-id="5799" />
                <path
                  d="M315.841531 672.418704c-0.239702-0.458741-0.462873-0.92988-0.698442-1.392753a180.789268 180.789268 0 0 1-4.186525-8.773931l-0.425679-0.987739a184.876605 184.876605 0 0 1-5.926432-15.295487c-0.223171-0.665381-0.475272-1.322495-0.694311-1.992009-7.885379-24.329784-11.125493-50.523461-11.865264-79.605963a563.192974 563.192974 0 0 1-0.169445-17.436277c0.095054-17.266832 0.859622-35.529668 1.938283-55.028211 67.124912-1.053864 138.8207-30.694294 214.029365-82.002987v-135.30782c-234.742951-123.116065-377.622059 224.869696-184.508786 411.072929-0.409147-0.648849-0.748037-1.310097-1.144785-1.963079-0.921614-1.500206-1.785369-3.016943-2.653257-4.53368-1.281168-2.235844-2.521007-4.488219-3.694722-6.752993zM698.675049 684.379023c61.669618-53.118858 88.846901-125.938767 89.785046-196.799729-1.49194 69.976543-28.727082 142.279852-89.785046 196.799729z"
                  fill="#FECF77" p-id="5800" />
                <path
                  d="M507.843081 409.903347c53.77184 54.123128 121.715047 87.863295 217.426526 82.002987 1.93415 14.977262 3.326903 29.053573 4.1204 42.423176 2.078798 34.810561 0.004133 64.765084-7.397709 93.029293-4.884968 18.651319-12.109099 36.579399-22.052613 54.652126-0.433944 0.785232-0.822427 1.578729-1.268769 2.368094 61.053831-54.515744 88.293106-126.823186 89.785046-196.799729 3.285575-154.525334-119.036993-297.689604-280.381444-212.863916l-0.23557-0.115719v135.303688z"
                  fill="#FF9F31" p-id="5801" />
              </svg>
              <div class="infoBox" style="margin-top: 0; padding-left: 40px">
                <p>
                  <span>{{ $t("slack.Name") }}:</span>
                  <el-tooltip effect="dark" :content="item.CustomerName6 || '-'" :disabled="isShowTooltip"
                    placement="bottom">
                    <span @mouseenter="getWidth($event)">
                      {{ item.CustomerName6 || "-" }}
                    </span>
                  </el-tooltip>
                </p>
                <p>
                  <span>{{ $t("slack.Phone") }}:</span>
                  <el-tooltip effect="dark" :content="item.telephone || '-'" :disabled="isShowTooltip"
                    placement="bottom">
                    <span @mouseenter="getWidth($event)">
                      {{ item.telephone || "-" }}
                    </span>
                  </el-tooltip>
                </p>
                <p>
                  <span>{{ $t("slack.Email") }}:</span>
                  <el-tooltip effect="dark" :content="item.email || '-'" :disabled="isShowTooltip" placement="bottom">
                    <span @mouseenter="getWidth($event)">
                      {{ item.email || "-" }}
                    </span>
                  </el-tooltip>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox">
          <p class="infoTitle">{{ $t("slack.AddressInformation") }}</p>
          <div class="AddressBox" v-for="(item, index) in ObjPopupData.ContactsData.getDetails" :key="index">
            {{ $t("slack.Address") }} {{ index + 1 }} : {{ item.address }}
          </div>
        </div>
        <div class="itemBox">
          <p class="infoTitle">{{ $t("slack.DescriptionInformation") }}</p>
          <div class="DescriptionBox">
            <el-tooltip effect="dark" :content="ObjPopupData.ContactsData.description || '-'" placement="bottom"
              :disabled="isShowTooltip" popper-class="SlackDescriptionContent">
              <p @mouseenter="getWidth($event)">
                {{ ObjPopupData.ContactsData.description || "-" }}
              </p>
            </el-tooltip>
          </div>
        </div>
        <div class="itemBox">
          <p class="infoTitle">{{ $t("slack.RelatedInformation") }}</p>
          <div class="RelatedBox" style="justify-content: start">
            <div class="RelatedItem">
              <div class="IconBox flex aic jc-c" style="background-color: rgb(236, 136, 128)">
                <i class="iconfont icon-a-QTN_huaban1 f20 fff"></i>
              </div>
              <p>
                {{ $t("slack.QTN") }}
                <strong>{{ ObjPopupData.RelatedQTNCount }}</strong>
              </p>
            </div>
            <div class="RelatedItem" style="margin-left: 20px">
              <div class="IconBox flex aic jc-c" style="background-color: #76bd55">
                <i class="iconfont icon-a-SalesOrders2_huaban1 f20 fff"></i>
              </div>
              <p>
                {{ $t("slack.Orders") }}
                <strong>{{ ObjPopupData.RelatedOrderCount }}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看对象详细相关数据 -->
    <el-dialog v-model="SaleOrdeInfo.Visible" align-center :show-close="false" draggable append-to-body
      class="SlackseeSaleOrdeInfo" :before-close="InfoCancel" :overflow="true">
      <template #header>
        <div class="flex aic jc-sb">
          <h4 v-if="SaleOrdeInfo.type == 'Tasks'">
            {{ $t("slack.RelatedPurchaseTasks") }} ({{
              SaleOrdeInfo.detailsData.PurchaseOrderteskNum
            }})
          </h4>
          <h4 v-if="SaleOrdeInfo.type == 'Order'">
            {{ $t("slack.RelatedPurchaseOrders") }} ({{
              SaleOrdeInfo.detailsData.PurchaseOrderNum
            }})
          </h4>
          <el-icon class="el-icon--left" @click="InfoCancel" style="cursor: pointer">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <template v-if="SaleOrdeInfo.type == 'Tasks'">
        <div class="PurchaseTasksBox" v-for="(item, index) in SaleOrdeInfo.data" :key="index">
          <div class="topInfo flex aic jc-sb">
            <p>
              <strong>ID:{{ item[0].PI_name }}</strong>
              <span style="margin-left: 10px; color: #333; font-style: italic">{{ item[0].state_text }}</span>
            </p>
            <strong>
              {{ $t("slack.Purchaser") }}: {{ item[0].purchaser }} |
              {{ item[0].create_time }}
            </strong>
          </div>
          <el-table border :data="item">
            <el-table-column :label="$t('slack.Model')" prop="Model" width="180" show-overflow-tooltip />
            <el-table-column label="SKU" show-overflow-tooltip>
              <template #default="scope">
                <p>{{ Number(scope.row.sku) || "-" }}</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slack.Brand')" prop="Brand_name" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Qty')" prop="Qtynumber" width="60" />
            <!-- <el-table-column :label="$t('slack.Purchaser')" prop="purchaser" show-overflow-tooltip /> -->
            <el-table-column :label="$t('slack.ListPrice')" prop="Price" width="100" show-overflow-tooltip>
              <template #default="scope">
                <i :class="[getCurrencyIcon(scope.row.Current), 'iconfont f14']"></i>
                <span>{{ Number(scope.row.Price) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slack.Inventory')" prop="stock_number" width="110" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Available')" prop="use_number" width="100" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Occupy')" prop="occupy_number" width="85" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Leading')" prop="lead" width="90" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Condition')" prop="product_condition" width="110"
              show-overflow-tooltip />
          </el-table>
        </div>
      </template>
      <template v-if="SaleOrdeInfo.type == 'Order'">
        <div class="PurchaseTasksBox" v-for="(item, index) in SaleOrdeInfo.data" :key="index">
          <div class="topInfo flex aic jc-sb">
            <p>
              <strong>ID:{{ item[0].Purchaseordername }}</strong>
              <span style="margin-left: 10px; color: #333; font-style: italic">{{ item[0].state_text }}</span>
            </p>
            <strong>
              {{ $t("slack.Purchaser") }}: {{ item[0].purchaser }} |
              {{ item[0].create_time }}
            </strong>
          </div>
          <el-table border :data="item">
            <el-table-column label="PI" prop="PI_name" width="100" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Model')" width="180" prop="Model" show-overflow-tooltip />
            <el-table-column label="SKU" prop="sku" width="100" show-overflow-tooltip>
              <template #default="scope">
                <p>{{ Number(scope.row.sku) || "-" }}</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slack.Brand')" prop="Brand_name" width="100" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Qty')" prop="dty" width="60" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Leading')" prop="Leading_name" width="90" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Condition')" prop="product_condition" width="110"
              show-overflow-tooltip />
            <el-table-column :label="$t('slack.ListCost')" prop="cost" width="90" show-overflow-tooltip>
              <template #default="scope">
                <i :class="[
                  getCurrencyIcon(scope.row.purchase_current),
                  'iconfont f14',
                ]"></i>
                <span>{{ Number(scope.row.cost) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slack.ListPrice')" prop="price" width="90" show-overflow-tooltip>
              <template #default="scope">
                <i :class="[
                  getCurrencyIcon(scope.row.sale_current),
                  'iconfont f14',
                ]"></i>
                <span>{{ Number(scope.row.price) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slack.Profit') + ' (%)'" prop="Profit" width="110" show-overflow-tooltip />
            <el-table-column :label="$t('slack.Total')" prop="Total" width="70" show-overflow-tooltip />
          </el-table>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { getTime, debounce, extend } from "../../utils/index";
import { HomeStore } from "../../index";
import { mapState } from "pinia";
import { CopyDocument, CloseBold, Close } from "@element-plus/icons-vue";
import * as Rfq from "@/api/apiRfq/index.js";
import * as Order from "@/api/apiPayOrder/index.js";
import * as $contact from "@/api/contactAccount/contact2.js";
import * as $axios from "../../api/index.js";
import { ElMessage } from "element-plus";
import { useDemoStore } from "@/pinia/index.js";
import { Kernaldec } from "@/hooks/useDecrypt.js";
import Dialog from "@/components/Dialog/Dialog.js";
import shipDetail from "./shipDetail.vue"
import i18n from "@/assets/lang";
export default {
  components: {
    shipDetail
  },
  data() {
    return {
      detailInfo: {
        showSearch: false,
        showSearch1: false,
        keywords: "",
        keywords1: "",
      },
      CloseBold,
      Close,
      CopyDocument,
      SaleOrdeInfo: {
        Isexpand: false,
        Visible: false,
        type: "",
        data: "",
        detailsData: {},
      },
      isShowTooltip: true,
      getTime,
      // 币种数据
      currencyList: [
        {
          name: "USD",
          icon: "icon-socialusd",
        },
        {
          name: "EUR",
          icon: "icon-eur",
        },
        {
          name: "CNY",
          icon: "icon-rmb fwb",
        },
        {
          name: "GBP",
          icon: "icon-gbp",
        },
        {
          name: "CAD",
          icon: "icon-a-C_huaban1_huaban1 fwb",
        },
        {
          name: "AUD",
          icon: "icon-a-A_huaban1 fwb",
        },
        {
          name: "HKD",
          icon: "icon-a-hk_huaban1 fwb f18",
        },
      ],
      NoDataText: useDemoStore().lang == "en-us" ? "No Data" : "暂无数据",
    };
  },
  computed: {
    ...mapState(HomeStore, ["ObjPopupData", "userInfo", "detailLoading"]),
    dialogueInfo() {
      return HomeStore().setting.dialogueInfo;
    },
  },
  watch: {
    ObjPopupData: {
      handler: function (val) {
        if (val.type == "SaleOrder") {
          if (this.userInfo.type != 4) {
            this.getStateList();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //获取销售订单状态
    getStateList() {
      Order.ordersConfigOrderState({
        token: HomeStore().token,
        lang: useDemoStore().lang,
      }).then((res) => {
        this.ordersStatusList = res.data.orders;
        this.ordersStatusList.unshift({
          code: "",
          massge: i18n.global.t("Order.sOrderAllstatus"),
        });
      });
    },
    //获取历史订单
    GetordersHistory(val) {
      if (val) {
        HomeStore().ObjPopupData.SaleOrderData.dataList =
          HomeStore().ObjPopupData.SaleOrderData.dataList1.filter((item) => {
            return item.statusList.includes(val);
          });
      } else {
        HomeStore().ObjPopupData.SaleOrderData.dataList = extend(
          HomeStore().ObjPopupData.SaleOrderData.dataList1,
          true
        );
      }
    },
    getCurrencyIcon(e) {
      if (!e) {
        return "icon-rmb fwb";
      } else {
        let icon = this.currencyList.find((item) => item.name == e);
        return icon.icon;
      }
    },
    getWidth(event) {
      if (event.target.scrollWidth > event.target.clientWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    //复制事件
    copyClick(type) {
      if (type == "SaleOrder") {
        let copyList = [];
        this.ObjPopupData.SaleOrderData.dataList.map((item) => {
          item.map((res) => {
            let str =
              res.product_name_pi +
              " * " +
              res.Qty +
              "\n" +
              "Brand:" +
              res.Brand_name +
              "\n" +
              "Condition:" +
              res.product_condition +
              "\n" +
              "Leading:" +
              res.leadingtime +
              "\n";
            if (
              this.userInfo.type == 1 ||
              this.userInfo.type == 2 ||
              this.userInfo.type == 16 ||
              this.userInfo.type == 6 ||
              this.userInfo.type == 7
            ) {
              str += "Cost:" + res.cost + "\n";
            }
            str += "Price:" + res.price + "\n\n";
            copyList.push(str);
          });
        });
        this.copyToClipboard(copyList.join(""));
        if (useDemoStore().lang == "en-us") {
          Dialog("Copy Success");
        } else {
          Dialog("复制成功");
        }
      }
    },
    copyToClipboard(textToCopy) {
      // navigator clipboard 需要https等安全上下文
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        return navigator.clipboard.writeText(textToCopy);
      } else {
        // 创建text area
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    //查看采购任务
    getPurchaseTasks(val) {
      if (val == 0) {
        return;
      }
      let purchaser_id = HomeStore().userInfo.user_uid;
      if (
        this.userInfo.type == 1 ||
        this.userInfo.type == 6 ||
        this.ObjPopupData.SaleOrderData.customer.create_user_id ==
        this.userInfo.user_uid ||
        this.ObjPopupData.SaleOrderData.customer.Sales_User_ID ==
        this.userInfo.user_uid
      ) {
        purchaser_id = "";
      }
      this.SaleOrdeInfo.detailsData = this.ObjPopupData.SaleOrderData;
      Order.purchaseOrderTakeList({
        token: HomeStore().token,
        PI_name: this.ObjPopupData.SaleOrderData.customer.PI_name,
        purchaser_id,
        page: 1,
        is_team: 1,
        pageSize: 10,
      }).then((res) => {
        if (res.Status == 1) {
          this.catchEvent();
          return;
        }
        if (res.data.length == 0) {
          this.catchEvent();
          return;
        }
        let purchase_tesk_ids = [];
        let purchase_tesk_List = res.data.data;
        res.data.data.map((item) => {
          purchase_tesk_ids.push({
            purchaseordertesk_id: item.purchaseordertesk_id,
          });
        });
        Order.purchaseOrderteskDetail({
          token: HomeStore().token,
          page: 1,
          pageSize: 20,
          purchase_tesk_ids,
        }).then((res) => {
          if (res.Status == 1) {
            this.catchEvent();
            return;
          }
          if (res.data.length == 0) {
            this.catchEvent();
            return;
          }
          this.SaleOrdeInfo.type = "Tasks";
          this.SaleOrdeInfo.Visible = true;
          window.parent.postMessage(
            {
              IsShowList: true,
            },
            "*"
          );
          let data = [];
          res.data.list.data.map((item) => {
            purchase_tesk_List.map((l) => {
              if (item.Purchaseordertesk_id == l.purchaseordertesk_id) {
                item.create_time = getTime(l.create_time, ".");
                item.purchaser = l.purchaser;
                item.PI_name = l.PI_name;
              }
            });
          });
          purchase_tesk_ids.map((item, index) => {
            data[index] = res.data.list.data.filter((i) => {
              return i.Purchaseordertesk_id == item.purchaseordertesk_id;
            });
          });
          this.SaleOrdeInfo.data = data;
        });
      });
    },
    //查看采购任务
    getPurchaseTasks1(val) {
      if (val == 0) {
        return;
      }
      let purchaser_id = HomeStore().userInfo.user_uid;
      if (
        this.userInfo.type == 1 ||
        this.userInfo.type == 6
      ) {
        purchaser_id = "";
      }
      this.SaleOrdeInfo.detailsData = this.ObjPopupData.PurchaseOrderData;
      Order.purchaseOrderTakeList({
        token: HomeStore().token,
        PI_name: this.ObjPopupData.PurchaseOrderData.PI_name,
        purchaser_id,
        page: 1,
        is_team: 1,
        pageSize: 10,
      }).then((res) => {
        if (res.Status == 1) {
          this.catchEvent();
          return;
        }
        if (res.data.length == 0) {
          this.catchEvent();
          return;
        }
        let purchase_tesk_ids = [];
        let purchase_tesk_List = res.data.data;
        res.data.data.map((item) => {
          purchase_tesk_ids.push({
            purchaseordertesk_id: item.purchaseordertesk_id,
          });
        });
        Order.purchaseOrderteskDetail({
          token: HomeStore().token,
          page: 1,
          pageSize: 20,
          purchase_tesk_ids,
        }).then((res) => {
          if (res.Status == 1) {
            this.catchEvent();
            return;
          }
          if (res.data.length == 0) {
            this.catchEvent();
            return;
          }
          this.SaleOrdeInfo.type = "Tasks";
          this.SaleOrdeInfo.Visible = true;
          window.parent.postMessage(
            {
              IsShowList: true,
            },
            "*"
          );
          let data = [];
          res.data.list.data.map((item) => {
            purchase_tesk_List.map((l) => {
              if (item.Purchaseordertesk_id == l.purchaseordertesk_id) {
                item.create_time = getTime(l.create_time, ".");
                item.purchaser = l.purchaser;
                item.PI_name = l.PI_name;
              }
            });
          });
          purchase_tesk_ids.map((item, index) => {
            data[index] = res.data.list.data.filter((i) => {
              return i.Purchaseordertesk_id == item.purchaseordertesk_id;
            });
          });
          this.SaleOrdeInfo.data = data;
        });
      });
    },
    //查看采购订单
    async getPurchaseOrders(val) {
      if (val == 0) {
        return;
      }
      if (!this.ObjPopupData.SaleOrderData.purchaseorderData) {
        this.catchEvent();
        return;
      }
      let purchaseorderData =
        this.ObjPopupData.SaleOrderData.purchaseorderData.data;
      let List = [];
      for (let i = 0; i < purchaseorderData.length; i++) {
        await new Promise((resolve) => {
          Order.purchaseOrderDetailed({
            token: HomeStore().token,
            page: 1,
            pageSize: 20,
            Purchaseorder_id: purchaseorderData[i].purchaseorder_id,
          }).then((res) => {
            res.data.data.map((item) => {
              item.create_time = getTime(purchaseorderData[i].create_time, ".");
              item.purchaser = purchaseorderData[i].create_name;
              item.Purchaseordername = purchaseorderData[i].Purchaseordername;
            });

            List[i] = res.data.data;
            if (i + 1 == purchaseorderData.length) {
              this.SaleOrdeInfo.data = List;
              this.SaleOrdeInfo.type = "Order";
              this.SaleOrdeInfo.Visible = true;
              window.parent.postMessage(
                {
                  IsShowList: true,
                },
                "*"
              );
            }
            resolve();
          });
        });
      }
    },
    //取消对象弹窗事件
    InfoCancel() {
      this.SaleOrdeInfo.Visible = false;
      window.parent.postMessage(
        {
          IsShowList: false,
        },
        "*"
      );
    },
    //发送QTN
    sendQTN(item, slackType) {
      if (this.ObjPopupData.slackType == "MyQTN") {
        Rfq.$orderget_order_purchase({
          token: HomeStore().token,
          inquiry_id: item.inquiry_id,
          isPublic: 4,
        }).then((res) => {
          res.data.qtn_createid = HomeStore().userInfo.user_uid;
          res.data.slackType = slackType;
          var data = {
            type: "PrivateChat",
            token: HomeStore().token, // 用户Token
            to_uid: HomeStore().setting.dialogueInfo.id, // 目标用户ID
            upload: "obj",
            obj_type: "QTN",
            obj_val: JSON.stringify(res.data),
            message: ``,
            website_id: HomeStore().setting.dialogueInfo.website_id || 1,
            shop_id: HomeStore().setting.dialogueInfo.website_id,
            channel: HomeStore().setting.dialogueInfo.website_name || "Shop",
            nowId: String(new Date().getTime()),
          };
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data);
          HomeStore().showDetail = false;
        });
      } else {
        Rfq.$orderget_order_purchase({
          token: HomeStore().token,
          inquiry_id: item.inquiry_id,
          isPublic: this.ObjPopupData.RFQdata.inquiryInfo.isPublic,
          slackType,
        }).then((res) => {
          res.data.qtn_createid = HomeStore().userInfo.user_uid;
          res.data.slackType = slackType;
          var data = {
            type: "PrivateChat",
            token: HomeStore().token, // 用户Token
            to_uid: HomeStore().setting.dialogueInfo.id, // 目标用户ID
            upload: "obj",
            obj_type: "QTN",
            obj_val: JSON.stringify(res.data),
            message: ``,
            website_id: HomeStore().setting.dialogueInfo.website_id || 1,
            shop_id: HomeStore().setting.dialogueInfo.website_id,
            channel: HomeStore().setting.dialogueInfo.website_name || "Shop",
            nowId: String(new Date().getTime()),
          };
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data);
          HomeStore().showDetail = false;
        });
      }
    },
    //搜索PurchaseQTN数据
    inputPurchaseQTN: debounce(function (val) {
      let List = [];
      List = HomeStore().ObjPopupData1.PurchaseQTN.item.filter((item) => {
        return (
          String(item.model)
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1 ||
          item.brand_name
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1 ||
          item.product_condition
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1 ||
          item.leadingtime
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1
        );
      });
      HomeStore().ObjPopupData.PurchaseQTN.item = List;
    }, 500),
    //搜索ContactQTN数据
    inputContactQTN: debounce(function (val) {
      let List = [];
      List = HomeStore().ObjPopupData1.ContactQTN.item.filter((item) => {
        return (
          String(item.model)
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1 ||
          item.brand_name
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1 ||
          item.product_condition
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1 ||
          item.leadingtime
            .toLocaleUpperCase()
            .indexOf(val.toLocaleUpperCase()) != -1
        );
      });
      HomeStore().ObjPopupData.ContactQTN.item = List;
    }, 500),
    //获取相关销售订单
    getRelatedSaleOrder() {
      let obj_val = "";
      let PI_name = this.ObjPopupData.PurchaseOrderData.data[0].PI_name;
      if (!PI_name) {
        return this.catchEvent();
      }

      Order.orderList({
        token: HomeStore().token,
        msg: 1,
        PI_name,
      }).then((res) => {
        if (res.Status == 1) {
          return;
        }
        let order_id = res.data.data[0].order_id;
        Order.orderDetail({
          token: HomeStore().token,
          order_id,
          page: 1,
          pageSize: 10,
          is_cost: 1,
          is_shipping: 1,
          msg: 1,
          // state: 0
        }).then((res) => {
          let status = [];
          let List = [];
          let dataList = [];
          let SubTotal = 0;
          let GrandTotal = 0;
          if (useDemoStore().lang == "en-us") {
            res.data.CustomerName6 =
              Kernaldec(res.data.customer.firstname) +
              Kernaldec(res.data.customer.lastname);
          } else {
            res.data.CustomerName6 =
              Kernaldec(res.data.customer.lastname) +
              Kernaldec(res.data.customer.firstname);
          }
          let customer = res.data.customer;
          res.data.list.data.map((item) => {
            item.statusList = [];
            item.status.map((state) => {
              if (status.indexOf(state.state) == -1) {
                status.push(state.state);
              }
              item.statusList.push(state.state);
              List.push({
                Brand_name: item.Brand_name,
                leadingtime: item.leadingtime,
                product_condition: item.product_condition,
                product_name_pi: item.product_name_pi,
                Qty: state.total,
                state_text: state.state_text,
                state: state.state,
                cost: item.cost,
                price: item.price,
              });
            });
            SubTotal += item.price * item.quantity;
          });
          status.map((item, index) => {
            dataList[index] = List.filter((i) => i.state == item);
          });
          GrandTotal =
            SubTotal -
            Number(customer.discount_value) +
            Number(customer.Payment_charge) +
            Number(customer.Shipping_cost) +
            Number(customer.Invoice_shipping_cost);

          res.data.dataList = res.data.list.data;
          res.data.dataList1 = extend(res.data.list.data, true);
          res.data.SubTotal = Number(SubTotal).toFixed(2);
          res.data.GrandTotal = Number(GrandTotal).toFixed(2);
          res.data.order_id = order_id;
          res.data.statusList = status;
          if (res.data.config_value) {
            res.data.config_value = res.data.payment.config_value
              .replace(",\r\n", "")
              .replace(/\n/g, "<br>");
          } else {
            if (res.data.payment.bank_name) {
              res.data.payment.config_value =
                res.data.payment.bank_name +
                `(${res.data.payment.currency})` +
                res.data.payment.account;
              res.data.payment.config_name = res.data.payment.bank_name;
            } else {
              res.data.payment.config_value = "-";
              res.data.payment.config_name = "-";
            }
          }
          let Contactsaddress = res.data.customer.address || "-";
          let companyAddress = res.data.company;
          if (useDemoStore().lang == "zh-cn") {
            Contactsaddress.address =
              Contactsaddress.city +
              "," +
              Contactsaddress.name +
              Contactsaddress.address;
            companyAddress.address =
              companyAddress.city +
              "," +
              companyAddress.name +
              companyAddress.address;
          }
          if (useDemoStore().lang == "en-us") {
            Contactsaddress.address =
              Contactsaddress.name +
              Contactsaddress.address +
              "," +
              Contactsaddress.city +
              "," +
              Contactsaddress.country;
            companyAddress.address =
              companyAddress.name +
              companyAddress.address +
              "," +
              companyAddress.city;
          }
          let PurchaseOrderteskNum = 0;
          let PurchaseOrderNum = 0;
          if (res.data.purtask_num) {
            PurchaseOrderteskNum =
              res.data.purtask_num >= 10
                ? res.data.purtask_num
                : "0" + res.data.purtask_num;
          }
          if (res.data.pur_num) {
            PurchaseOrderNum =
              res.data.purtask_num >= 10
                ? res.data.pur_num
                : "0" + res.data.pur_num;
          }
          obj_val = res.data;
          obj_val.PurchaseOrderteskNum = PurchaseOrderteskNum;
          obj_val.PurchaseOrderNum = PurchaseOrderNum;
          obj_val.PI_name = PI_name;
          HomeStore().ObjPopupData.SaleOrderData = obj_val;
          HomeStore().savePopupData = this.ObjPopupData;
          HomeStore().ObjPopupData.type = "SaleOrder";
          HomeStore().isDetail = true;
          HomeStore().showDetail = true;
          HomeStore().isReply = false;
          HomeStore().switchPopupData.show = true;
          this.getPurchaseOrdersList();
          let index = HomeStore().switchPopupData.data.findIndex((item) => {
            return item.data == PI_name;
          });
          if (index == -1) {
            HomeStore().switchPopupData.data.push({
              data: PI_name,
              type: "SaleOrder",
              user_uid: this.dialogueInfo.id,
            });
          }

          if (HomeStore().switchPopupData.data.length == 1) {
            HomeStore().switchPopupData.data.push({
              data: this.ObjPopupData.PurchaseOrderData.Purchaseordername,
              type: "PurchaseOrder",
              user_uid: this.dialogueInfo.id,
            });
          }
        });
      });
    },
    //获取采购订单的数据
    getPurchaseOrdersList() {
      Order.purchaseOrderTakeList({
        token: HomeStore().token,
        PI_name: HomeStore().ObjPopupData.SaleOrderData.PI_name,
        page: 1,
        pageSize: 10,
        is_team: 1,
        // purchaser_id: HomeStore().userInfo.user_uid
      }).then((res) => {
        let purchase_tesk_ids = [];
        if (res.data.total) {
          res.data.data.map((item) => {
            purchase_tesk_ids.push({
              purchaseordertesk_id: item.purchaseordertesk_id,
            });
          });
          Order.purchaseOrderteskDetail({
            token: HomeStore().token,
            page: 1,
            pageSize: 20,
            purchase_tesk_ids,
          }).then((res2) => {
            if (res2.data.length == 0) {
              return;
            }
            let Purchaseordertesk_detailed_id = [];
            res2.data.list.data.map((item) => {
              Purchaseordertesk_detailed_id.push(
                item.Purchaseordertesk_detailed_id
              );
            });
            Order.purchaseOrderList({
              token: HomeStore().token,
              page: 1,
              pageSize: 10,
              is_team: 1,
              Purchaseordertesk_detailed_id,
            }).then((res) => {
              if (res.Status == 1) {
                return;
              }
              HomeStore().ObjPopupData.SaleOrderData.purchaseorderData =
                res.data;
            });
          });
        }
      });
    },
    //查看联系人详情
    getContactsDetails(type, Contacts) {
      let customer_info_id = "";
      HomeStore().ObjPopupData.RelatedRFQCount = 0;
      if (type == "RFQ") {
        customer_info_id =
          this.ObjPopupData.RFQdata.inquiryInfo.customer_info_id;
      } else if (type == "QTN") {
        customer_info_id =
          this.ObjPopupData.RFQdata.inquiryInfo.customer_info_id;
      } else if (type == "SaleOrder") {
        customer_info_id =
          this.ObjPopupData.SaleOrderData.customer.Customer_Seller_info_id;
      }
      $contact
        .contactsDetails({
          customer_info_id,
        })
        .then((res) => {
          if (res.data.length == 0) {
            this.catchEvent();
            return;
          }
          let owner_names = [];
          res.data.owners.map((item) => {
            owner_names.push(item.owner_name);
          });
          res.data.owner_names = owner_names.join("、");
          HomeStore().ObjPopupData.type = "Contacts";
          res.data.address.map((item) => {
            if (useDemoStore().lang == "en-us") {
              item.address =
                item.address + "," + item.city + "," + item.country_name;
            }
            if (useDemoStore().lang == "zh-cn") {
              item.address =
                item.country_name + "," + item.city + "," + item.address;
            }
          });
          if (useDemoStore().lang == "en-us") {
            res.data.CustomerName6 =
              Kernaldec(res.data.firstname) + Kernaldec(res.data.lastname);
          } else {
            res.data.CustomerName6 =
              Kernaldec(res.data.lastname) + Kernaldec(res.data.firstname);
          }
          // res.data.arrCustomerInfo.map((Customer) => {
          //   Customer.CustomerName6 = Kernaldec(Customer.firstname);
          // });
          HomeStore().ObjPopupData.ContactsData = res.data;
          HomeStore().savePopupData = this.ObjPopupData;
          HomeStore().switchPopupData.show = true;
          let index = HomeStore().switchPopupData.data.findIndex((item) => {
            return item.id == customer_info_id;
          });
          if (index == -1) {
            HomeStore().switchPopupData.data.push({
              data: Contacts,
              type: "Contact",
              id: customer_info_id,
              user_uid: this.dialogueInfo.id,
            });
          }
          if (HomeStore().switchPopupData.data.length == 1) {
            if (type == "RFQ") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.RFQdata.inquiryInfo.inquiry_id,
                type: "RFQ",
                user_uid: this.dialogueInfo.id,
              });
            } else if (type == "QTN") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.RFQdata.inquiryInfo.inquiry_id,
                type: "QTN",
                user_uid: this.dialogueInfo.id,
              });
            } else if (type == "SaleOrder") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.SaleOrderData.PI_name,
                type: "SaleOrder",
                user_uid: this.dialogueInfo.id,
              });
            }
          }
        });
      Rfq.$pollingOutside_polling({
        token: HomeStore().token,
        keywords: "",
        customer_info_id,
      }).then((res) => {
        HomeStore().ObjPopupData.RelatedRFQData = res.data.data;
        HomeStore().ObjPopupData.RelatedRFQCount = res.data.total;
      });
      Rfq.$pollingOutside_polling({
        token: HomeStore().token,
        keywords: "",
        customer_info_id,
        isQTN: 1,
      }).then((res) => {
        HomeStore().ObjPopupData.RelatedQTNData = res.data.data;
        HomeStore().ObjPopupData.RelatedQTNCount = res.data.total;
      });
      Order.orderList({
        token: HomeStore().token,
        customer_info_id,
        page: 1,
        limit: 20,
      }).then((res) => {
        HomeStore().ObjPopupData.RelatedOrderData = res.data.data;
        HomeStore().ObjPopupData.RelatedOrderCount = res.data.total;
      });
    },
    //查看供应商详情
    async getvendorsDetails(type, vendor) {
      let company_id = "";
      let company_id1 = "";

      if (type == "PurchaseOrder") {
        company_id = this.ObjPopupData.PurchaseOrderData.supplier_company_id;
        company_id1 = this.ObjPopupData.PurchaseOrderData.supplier_id;
      } else if (type == "QTN") {
        company_id = this.ObjPopupData.ContactQTN.supplier_id;
        company_id1 = this.ObjPopupData.ContactQTN.supplier_id;
      } else if (type == "SaleOrder") {
        company_id = this.ObjPopupData.SaleOrderData.customer.company_id;
        company_id1 = this.ObjPopupData.SaleOrderData.customer.company_id;
      } else if (type == "RFQ") {
        company_id = this.ObjPopupData.RFQdata.inquiryInfo.customer.vendor_id;
        company_id1 =
          this.ObjPopupData.RFQdata.inquiryInfo.customer.customer_info_id;
      }

      $contact
        .vendorsDetails({
          company_id,
        })
        .then((res) => {
          if (res.data.length == 0) {
            this.catchEvent();
            return;
          }
          res.data.getDetails.map((item) => {
            if (useDemoStore().lang == "en-us") {
              item.address =
                item.address + "," + item.city + "," + item.country_name;
            }
            if (useDemoStore().lang == "zh-cn") {
              item.address =
                item.country_name + "," + item.city + "," + item.address;
            }
          });
          HomeStore().ObjPopupData.type = "Vendor";
          res.data.CompanyName = Kernaldec(res.data.CompanyName);
          res.data.arrCustomerInfo.map((Customer) => {
            Customer.CustomerName6 = Kernaldec(Customer.firstname);
          });
          HomeStore().ObjPopupData.ContactsData = res.data;
          HomeStore().savePopupData = this.ObjPopupData;
          HomeStore().switchPopupData.show = true;
          let index = HomeStore().switchPopupData.data.findIndex((item) => {
            return item.id == company_id;
          });
          if (index == -1) {
            HomeStore().switchPopupData.data.push({
              data: vendor,
              type: "Vendor",
              id: company_id,
              user_uid: this.dialogueInfo.id,
            });
          }

          if (HomeStore().switchPopupData.data.length == 1) {
            if (type == "PurchaseOrder") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.PurchaseOrderData.Purchaseordername,
                type: "PurchaseOrder",
                user_uid: this.dialogueInfo.id,
              });
            }
            if (type == "QTN") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.RFQdata.inquiryInfo.inquiry_id,
                type: "QTN",
                user_uid: this.dialogueInfo.id,
              });
            }
            if (type == "SaleOrder") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.SaleOrderData.PI_name,
                type: "SaleOrder",
                user_uid: this.dialogueInfo.id,
              });
            }
            if (type == "RFQ") {
              HomeStore().switchPopupData.data.push({
                data: this.ObjPopupData.RFQdata.inquiryInfo.inquiry_id,
                type: "RFQ",
                user_uid: this.dialogueInfo.id,
              });
            }
          }
        });
      if (this.userInfo.type != 4) {
        Rfq.$pollingOutside_polling({
          token: HomeStore().token,
          keywords: "",
          customer_info_id: company_id1,
          isQTN: 1,
        }).then((res) => {
          HomeStore().ObjPopupData.RelatedQTNData = res.data.data;
          HomeStore().ObjPopupData.RelatedQTNCount = res.data.total;
        });
        // cpoList
        Order.purchaseOrderList({
          token: HomeStore().token,
          supplier_id: company_id1,
          page: 1,
          limit: 20,
        })
          .then((res) => {
            HomeStore().ObjPopupData.RelatedOrderData = res.data.data;
            HomeStore().ObjPopupData.RelatedOrderCount = res.data.total;
          })
          .catch(() => {
            HomeStore().ObjPopupData.RelatedOrderData = 0;
            HomeStore().ObjPopupData.RelatedOrderCount = 0;
          });
      } else {
        Rfq.$pollingOutside_polling({
          token: HomeStore().token,
          keywords: "",
          customer_info_id: company_id1,
          isQTN: 1,
        }).then((res) => {
          HomeStore().ObjPopupData.RelatedQTNData = res.data.data;
          HomeStore().ObjPopupData.RelatedQTNCount = res.data.total;
        });
        // cpoList
        Order.cpoList({
          token: HomeStore().token,
          supplier_id: company_id1,
          page: 1,
          pageSize: 20,
          owner_id: this.userInfo.user_uid,
        })
          .then((res) => {
            HomeStore().ObjPopupData.RelatedOrderData = res.data.data;
            HomeStore().ObjPopupData.RelatedOrderCount = res.data.total;
          })
          .catch(() => {
            HomeStore().ObjPopupData.RelatedOrderData = 0;
            HomeStore().ObjPopupData.RelatedOrderCount = 0;
          });
      }
    },
    //关闭详情页
    Closedetail() {
      HomeStore().isDetail = false;
      HomeStore().showDetail = false;
      HomeStore().savePopupData = extend(this.ObjPopupData, true);
      HomeStore().switchPopupData.show = true;
      if (HomeStore().switchPopupData.data.length > 0) {
        return;
      }
      if (this.ObjPopupData.type == "PurchaseOrder") {
        HomeStore().switchPopupData.data.push({
          data: this.ObjPopupData.PurchaseOrderData.Purchaseordername,
          type: "PurchaseOrder",
          user_uid: this.dialogueInfo.id,
        });
      }
      if (this.ObjPopupData.type == "RFQ") {
        HomeStore().switchPopupData.data.push({
          data: this.ObjPopupData.RFQdata.inquiryInfo.inquiry_id,
          type: "RFQ",
          user_uid: this.dialogueInfo.id,
        });
      }
      if (this.ObjPopupData.type == "QTN") {
        HomeStore().switchPopupData.data.push({
          data: this.ObjPopupData.RFQdata.inquiryInfo.inquiry_id,
          type: "QTN",
          user_uid: this.dialogueInfo.id,
        });
      }
      if (this.ObjPopupData.type == "SaleOrder") {
        HomeStore().switchPopupData.data.push({
          data: this.ObjPopupData.SaleOrderData.PI_name,
          type: "SaleOrder",
          user_uid: this.dialogueInfo.id,
        });
      }
    },
    //错误处理
    catchEvent() {
      if (useDemoStore().lang == "en-us") {
        ElMessage({
          type: "info",
          message: "No Data",
        });
      } else {
        ElMessage({
          type: "info",
          message: "没有数据",
        });
      }
    },
  },
};
</script>
<style lang="less">
.ObjPopupdetail {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  padding: 10px;
  z-index: 9;
  overflow: auto;

  .detailBox {
    height: 100%;
    background: #fff;

    .flexpane_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 20px;
      height: 50px;
      border-bottom: 1px solid #d7e2ed;

      .flexpane__subtitle {
        width: calc(100% - 16px);
        padding-left: 10px;
        font-size: 16px;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .detail_body {
      height: calc(100% - 50px);
      overflow: auto;
    }

    .headerInfo {
      padding: 10px 0;
      margin: 0 20px;
      color: #333;
      border-bottom: dashed 1px #d7e2ed;
      font-size: 14px;

      .Sales {
        display: flex;
        align-items: center;

        span:last-child {
          font-size: 16px;
          font-weight: 700;
          margin-left: 5px;
          width: calc(100% - 60px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .Contacts {
        margin-top: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;

        span:last-child {
          font-weight: 700;
          margin-left: 5px;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .itemBox {
      padding: 15px 0;
      margin: 0 20px;
      border-bottom: dashed 1px #d7e2ed;
      color: #333;

      .infoTitle {
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
      }

      .TitleBox {
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
      }
    }

    .ModelBox {
      .Modelwrap {
        box-shadow: rgba(0, 0, 0, 0.4) 0px 0.1px 5px 0px;
        border-radius: 4px;
        padding: 10px;
        margin-top: 15px;
        max-height: 150px;
        overflow: auto;

        .Model {
          font-size: 14px;
          color: #333;

          // margin-bottom: 5px;
          p {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        // .Model:last-child {
        //   margin-bottom: 0;
        // }
      }
    }

    .QTNItem {
      margin-top: 12px;

      .stateBox {
        padding: 8px 12px;
        background-color: #f8f8f8;
        // border-radius: 4px;
        margin-top: 10px;
        color: #555555;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        border-bottom: solid 2px #fff;
      }

      .QTNBox {
        padding: 8px 12px;
        background-color: #f8f8f8;
        font-size: 14px;
        color: #333;
        position: relative;

        p {
          margin-bottom: 12px;
          display: flex;
          align-items: center;
        }

        .Model {
          font-weight: 700;
        }

        .Price {
          color: #e96c45;
        }

        button {
          background: none;
          border: none;
          height: 42px;
          width: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background-color: #fff;
          position: absolute;
          bottom: 12px;
          right: 12px;
          border: solid 1px #cad2d9;
          cursor: pointer;

          svg {
            fill: #cad2d9;
            margin-left: 2px;
          }
        }

        button:hover {
          background-color: #3370ff;

          svg {
            fill: #fff;
          }
        }
      }
    }

    .PurchaseQTNBox,
    .ContactQTNBox {
      .TitleBox {
        font-size: 18px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon-sousuo {
          margin-top: 3px;
        }

        .deleteIcon {
          color: #333;
          font-size: 15px;
          margin-left: 5px;
        }
      }
    }

    .bottomInfo {
      font-style: italic;
      font-size: 14px;
      color: #555555;
      margin-top: 10px;
    }
  }

  .QTNdetailBox {
    .detail_body {
      .itemBox {
        border-bottom: solid 1px #d7e2ed;
        margin: 0;
        padding: 20px;

        .RelatedRFQ {
          margin-top: 10px;

          p {
            margin-bottom: 7px;
            display: flex;

            span {
              white-space: nowrap;
            }

            span:last-child {
              font-weight: 700;
              margin-left: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          p:last-child {
            margin-bottom: 0;
          }
        }
      }

      .ModelBox {
        border-bottom: none !important;
      }
    }
  }

  .SaleOrderBox,
  .PurchaseOrderBox {
    .ModelBox {
      .ModelNumDiv {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .num {
          font-size: 16px;
          font-weight: 700;
        }

        .CurrentBox {
          p {
            padding: 5px;
            background-color: #a2acbb;
            color: #fff;
            font-size: 14px;
            border-radius: 4px;
          }

          i {
            margin-left: 5px;
          }
        }
      }

      .ModelList {
        margin-top: 10px;
        max-height: 350px;
        overflow: auto;

        .Models {
          background: #f2f4f7;
          padding: 5px 10px;
          border-radius: 4px;
          margin-bottom: 10px;

          .stateBox {
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;

            .state_text {
              color: #555;
              margin-left: 5px;
            }
          }

          .Model {
            font-size: 14px;
            margin-bottom: 5px;

            .modelDiv {
              display: flex;
              justify-content: space-between;

              .ModelName {
                font-weight: 700;
                margin-bottom: 5px;
                width: calc(100% - 60px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }

            .infoDiv {
              p {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-top: 3px;
              }
            }
          }
        }

        .Models:last-child {
          margin-bottom: 0;
        }

        .Model:last-child {
          margin-bottom: 0;
        }

        .NoBottom {
          margin-bottom: 0 !important;
        }
      }
    }

    .FeeBox {
      .infoTitle {
        margin-bottom: 10px;
      }

      .FeeData {
        div {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 5px;

          i {
            position: relative;
            right: -3px;
          }
        }
      }
    }

    .DetailsBox {
      font-size: 14px;
      color: #333;

      .infoTitle {
        margin-bottom: 10px;
      }

      .BankBox {
        margin-top: 10px;
        background-color: #f2f4f7;
        padding: 10px 15px;
        border-radius: 4px;
        color: #555;
        line-height: 1.5;
        max-height: 78px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-bottom: 15px;
      }

      .ContactsBox {
        display: flex;
        background-color: #f2f4f7;
        padding: 10px 15px;
        border-radius: 4px;
        margin-top: 10px;
        margin-bottom: 15px;

        .addressTxt {
          width: calc(100% - 80px);
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .icon-dizhi {
          margin-top: 2px;
        }
      }

      >p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .ContactsDetailsBox {
    .itemBox {
      .ContactsName {
        display: flex;
        align-items: center;
      }

      .Owner {
        margin-left: 20px;
        color: #7f7f7f;
        /*height: 56px;*/
        display: flex;
        flex-direction: column;
        font-size: 14px;
        width: calc(100% - 65px);
        white-space: nowrap;

        strong {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .infoBox {
        margin-top: 20px;

        p {
          margin-bottom: 5px;
          font-size: 16px;
          color: #000;
          display: flex;

          span:first-child {
            color: #333;
            white-space: nowrap;
          }

          span:last-child {
            font-weight: 700;
            margin-left: 3px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .AddressBox {
        margin-top: 10px;
        background-color: #f8f8f8;
        padding: 10px;
        color: #333;
        cursor: pointer;
        display: -webkit-box;
        // -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .RelatedBox {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;

        .RelatedItem {
          display: flex;
          flex-direction: column;
          align-items: center;

          .IconBox {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            margin-bottom: 5px;
          }
        }
      }

      .DescriptionBox {
        color: #333;

        p {
          cursor: pointer;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow-wrap: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .VendorContacts {
        margin-top: 10px;

        .VendorContactsItem {
          margin-top: 10px;
          position: relative;

          >svg {
            position: absolute;
          }
        }
      }
    }
  }

  .Contacts {
    cursor: pointer;
  }
}

.SlackDescriptionContent {
  max-width: 700px;
}

.SlackseeSaleOrdeInfo {
  width: 800px;

  .el-dialog__header {
    margin-right: 0 !important;
  }

  .el-dialog__body {
    padding: 10px 20px 20px 20px !important;
    max-height: 725px;
    overflow: auto;

    .PurchaseTasksBox {
      color: #333;
      box-shadow: 0 0.1px 5px 0 rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 10px;
      max-height: 70vh;
      overflow: auto;

      .topInfo {
        font-size: 16px;
        margin-bottom: 10px;
      }

      .el-table {
        .el-table__header {
          th {
            background: #f2f4f7;
            height: 40px;
            color: #333;
            font-size: 14px;
            font-weight: bold;
            border-right: solid 1px #d7e2ed;
          }
        }

        .el-table__body-wrapper {
          td {
            border: none !important;
            height: 40px;
            font-size: 13px;

            .cell {
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>
